{
  "createHub": {
    "title": "Crea",
    "open": "Crea",
    "close": "Chiudi",
    "actionsHeader": "Avvia",
    "newWorkout": {
      "title": "Nuovo allenamento",
      "sub": "Inizia subito un allenamento vuoto"
    },
    "repeatWorkout": {
      "title": "Ripeti allenamento",
      "sub": "Registra di nuovo da un allenamento passato"
    },
    "planProgram": {
      "title": "Pianifica un programma",
      "sub": "Crea un programma di più settimane"
    },
    "planWorkout": {
      "title": "Pianifica un allenamento",
      "sub": "Prepara una singola sessione per dopo"
    }
  },
  "library": {
    "header": "Sfoglia",
    "tabPrograms": "Programmi",
    "tabWorkouts": "Allenamenti",
    "tabPersonal": "Personali",
    "tabCoach": "Coach",
    "tabFavorites": "Preferiti",
    "favoriteA11y": "Preferito",
    "errFavorite": "Impossibile aggiornare i preferiti.",
    "emptyFavoritesTitle": "Nessun preferito",
    "emptyFavoritesSub": "Tocca la stella su un programma o un allenamento per tenerlo qui.",
    "sectionOfficial": "Di JackedLogs",
    "sectionPersonal": "Personali",
    "clone": "Clona",
    "copySuffix": "(copia)",
    "following": "Attivazione…",
    "searchPlaceholder": "Cerca per nome…",
    "filters": "Filtri",
    "clearFilters": "Azzera",
    "axisLevel": "Livello",
    "axisPerWeek": "Sessioni / settimana",
    "noResultsTitle": "Nessun risultato",
    "noResultsSub": "Modifica la ricerca o i filtri.",
    "loading": "Carico la libreria…",
    "errLoad": "Impossibile caricare la libreria.",
    "errClone": "Clonazione non riuscita. Riprova.",
    "errDelete": "Eliminazione non riuscita. Riprova.",
    "errFollow": "Impossibile seguire il programma.",
    "errStatus": "Impossibile aggiornare il programma.",
    "emptyTitle": "Ancora niente qui",
    "emptySub": "I programmi e gli allenamenti che crei o cloni compaiono qui.",
    "coachSoonTitle": "Dal coach",
    "coachSoonSub": "I programmi e gli allenamenti assegnati dal coach compaiono qui."
  },
  "common": {
    "lastDataAt": "Ultimo dato {{at}}",
    "languageA11y": "Lingua",
    "infoA11y": "Info",
    "unsavedChanges": {
      "title": "Scartare le modifiche?",
      "body": "Le modifiche non salvate andranno perse.",
      "keepEditing": "Continua a modificare",
      "discard": "Scarta"
    }
  },
  "bodymap": {
    "viewBack": "Schiena",
    "viewFront": "Fronte",
    "workedTitle": "Muscoli lavorati",
    "workedPrimary": "primari",
    "workedSecondary": "secondari",
    "heatmapTitle": "Muscoli più allenati",
    "heatmapLow": "poco",
    "heatmapHigh": "molto",
    "window7d": "7 giorni",
    "window30d": "30 giorni",
    "painTitle": "Mappa del dolore",
    "painHelp": "Tocca un muscolo per marcarlo: rosso (no carichi pesanti), giallo (attenzione). Salvato automaticamente.",
    "painRed": "evita",
    "painYellow": "attenzione",
    "painClearAll": "Cancella tutto",
    "painSaving": "Salvataggio…",
    "painSaveError": "Salvataggio fallito. Controlla la connessione.",
    "painRiskA11y": "Rischio dolore: {{severity}}",
    "painSeverity": {
      "red": "alto",
      "yellow": "medio",
      "green": "basso"
    }
  },
  "plates": {
    "title": "Carico dischi",
    "openHint": "Mostra il carico dei dischi",
    "close": "Chiudi",
    "targetLabel": "Obiettivo",
    "barLabel": "Bilanciere",
    "barAria": "Peso del bilanciere",
    "barNone": "Senza bilanciere",
    "perSide": "Per lato",
    "perSidePair": "{{count}} × {{plate}}",
    "barOnly": "Solo il bilanciere — non servono dischi.",
    "belowBar": "L'obiettivo è più leggero del bilanciere.",
    "invalidInput": "Inserisci prima un peso valido.",
    "remainder": "+{{weight}} sotto l'obiettivo con l'inventario attuale.",
    "fallbackPill": "massimo possibile",
    "inventoryLegend": "Coppie disponibili",
    "inventoryHint": "Coppie di ogni disco disponibili adesso. Metti 0 se la palestra non ce l'ha o se sono tutti occupati. Salvato tra le sessioni.",
    "pairsAria": "Coppie di {{plate}} disponibili",
    "loadedEnd": "Estremità caricata",
    "landmineHint": "Landmine: viene caricata solo l'estremità libera. L'altra estremità è ancorata al perno a terra."
  },
  "app": {
    "title": "JackedLogs",
    "tagline": "Allenamento di forza, registrato senza fronzoli.",
    "signedInAs": "Accesso effettuato come <bold>{{email}}</bold>.",
    "signOut": "Esci",
    "loading": "Caricamento…",
    "checking": "verifica in corso…"
  },
  "auth": {
    "signIn": "Accedi",
    "signInFailed": "Accesso non riuscito. Controlla email e password.",
    "createAccount": "Crea account",
    "email": "Email",
    "emailPlaceholder": "email@esempio.com",
    "password": "Password",
    "passwordHint": "Almeno 10 caratteri con maiuscola, minuscola e un numero.",
    "switchToSignUp": "Non hai un account? Creane uno.",
    "switchToSignIn": "Hai già un account? Accedi.",
    "submitting": "Attendi…",
    "confirmTitle": "Conferma la tua email",
    "confirmHelp": "Ti abbiamo inviato un codice a <bold>{{email}}</bold>. Incollalo qui sotto per completare la registrazione.",
    "confirmCode": "Codice di conferma",
    "confirmSubmit": "Conferma",
    "confirming": "Conferma in corso…",
    "resendCode": "Rinvia il codice",
    "resentInfo": "Codice rinviato. Controlla la tua casella di posta.",
    "confirmedNowSignIn": "Account confermato. Accedi per continuare.",
    "forgotLink": "Hai dimenticato la password?",
    "forgotTitle": "Reimposta la password",
    "forgotIntro": "Inserisci la tua email e ti invieremo un codice per reimpostare la password.",
    "forgotSendCode": "Invia codice",
    "forgotCodeSent": "Codice inviato. Controlla la posta.",
    "forgotConfirmHelp": "Codice inviato a <bold>{{email}}</bold>. Inseriscilo qui sotto con la nuova password.",
    "forgotResetSubmit": "Reimposta password",
    "forgotResetDone": "Password aggiornata. Accedi con la nuova.",
    "newPassword": "Nuova password",
    "backToSignIn": "Torna all'accesso"
  },
  "dashboard": {
    "meTitle": "Round-trip autenticato — /api/me",
    "healthTitle": "Stato API",
    "exportData": "Esporta i miei dati",
    "deleteAccount": "Elimina il mio account",
    "exporting": "Preparazione export…",
    "deleting": "Eliminazione…",
    "deleteConfirm": "Verranno eliminati definitivamente il tuo account e tutti i tuoi dati. Scrivi ELIMINA per confermare.",
    "deleteCancel": "Annulla",
    "deletePlaceholder": "ELIMINA",
    "deleteSuccess": "Account eliminato.",
    "exportFilename": "jackedlogs-export-{{date}}.json",
    "privacyTitle": "Privacy",
    "privacyHelp": "Esporta tutto in JSON o cancella l'account in modo definitivo. Le cancellazioni non si recuperano."
  },
  "privacy": {
    "linkLabel": "Privacy",
    "title": "Informativa sulla privacy",
    "lastUpdated": "Ultimo aggiornamento: 27 agosto 2026 (base giuridica)",
    "intro": "Metria è realizzata e gestita da Heraion. Questa informativa spiega cosa raccogliamo, dove vivono i dati e cosa puoi farci.",
    "section1Title": "Cosa raccogliamo",
    "section1Body": "Solo lo stretto necessario al funzionamento del servizio: il tuo indirizzo email (usato come identificativo dell'account), una password cifrata (gestita da Amazon Cognito — il testo in chiaro non lascia mai il tuo browser) e i dati di allenamento che scegli di inserire. Non raccogliamo nome, indirizzo, numero di telefono, data di nascita o alcuna impronta analitica. Il peso corporeo è opzionale: se lo inserisci nel profilo l'app può calcolare il carico effettivo negli esercizi a corpo libero (dip, chin-up, ecc.). È trattato come dato sanitario di categoria particolare ai sensi dell'art. 9 GDPR e dell'art. 5 lett. c nLPD: mai aggregato, mai registrato nei log, cancellato insieme agli altri dati alla cancellazione dell'account.",
    "section2Title": "Dove vivono i dati",
    "section2Body": "Tutti i dati sono archiviati nella regione AWS eu-central-2 (Zurigo, Svizzera). L'autenticazione gira su Amazon Cognito; i dati strutturati su Amazon DynamoDB; gli asset statici su Amazon CloudFront. Non utilizziamo alcun servizio di analytics, pubblicità o tracking di terze parti.",
    "section3Title": "I tuoi diritti",
    "section3Body": "In qualsiasi momento puoi esportare l'intero set di dati (JSON) oppure eliminare definitivamente il tuo account dalla dashboard. L'eliminazione rimuove il record di autenticazione e ogni dato collegato al tuo account, senza alcun soft-delete.",
    "section4Title": "Contatti",
    "section4Body": "Domande o richieste: {{email}}.",
    "section5Title": "Base giuridica",
    "section5Body": "La base giuridica del trattamento, ai sensi della nLPD svizzera e del GDPR UE, è il tuo consenso al momento della registrazione e l'interesse legittimo a fornire il servizio richiesto. Aggiorneremo questa informativa prima di qualsiasi ampliamento di scopo.",
    "back": "Indietro"
  },
  "errors": {
    "generic": "Qualcosa è andato storto."
  },
  "feedback": {
    "title": "Invia feedback",
    "help": "Hai trovato un bug, vuoi una feature o qualcos'altro? Scrivilo qui. I messaggi finiscono nella inbox dell'admin.",
    "kindLabel": "Tipo",
    "kind_bug": "Bug",
    "kind_feature": "Richiesta funzionalità",
    "kind_other": "Altro",
    "bodyLabel": "Cosa è successo?",
    "bodyPlaceholder": "Descrivi cosa hai visto, cosa ti aspettavi e come riprodurlo.",
    "send": "Invia",
    "sending": "Invio…",
    "sentFlash": "Grazie — inviato.",
    "sentHint": "Lo gestiremo nella prossima sessione. Puoi chiudere.",
    "close": "Chiudi",
    "errEmpty": "Scrivi qualcosa prima di inviare.",
    "errSubmit": "Invio non riuscito. Riprova fra poco.",
    "errRateLimit": "Troppi invii nell'ultima ora. Riprova più tardi.",
    "inboxTitle": "Inbox feedback",
    "loading": "Caricamento feedback…",
    "empty": "Nessun feedback da mostrare.",
    "filterAll": "Tutti",
    "loadMore": "Carica altri",
    "status_open": "Aperto",
    "status_in_progress": "In corso",
    "status_shipped": "Risolto",
    "status_wontfix": "Non risolto",
    "priorityLabel": "Priorità",
    "priorityNone": "Nessuna",
    "statusLabel": "Stato",
    "head_open": "{{count}} aperti",
    "head_in_progress": "{{count}} in corso",
    "head_shipped": "{{count}} risolti",
    "head_wontfix": "{{count}} non risolti",
    "headTotal": "{{count}} in totale"
  },
  "profile": {
    "title": "Profilo",
    "loading": "Caricamento profilo…",
    "name": "Nome visualizzato",
    "namePlaceholder": "Come dobbiamo chiamarti?",
    "role": "Ruolo",
    "roleCoach": "Coach",
    "roleAthlete": "Atleta",
    "roleBoth": "Entrambi",
    "ageBucket": "Fascia d'età (facoltativa)",
    "ageBucketHelp": "Utilizzata solo per statistiche di gruppo anonime opt-in. Resta vuota se non la compili.",
    "ageBucketNone": "Preferisco non rispondere",
    "unitsPreference": "Unità preferita",
    "unitsPreferenceHelp": "I pesi sono sempre archiviati in chilogrammi. Per ogni serie potrai cambiare l'unità di input.",
    "preferredFigure": "Figura del corpo sulla bodymap",
    "preferredFigureHelp": "Scegli la figura su cui rendere la muscle map. Indipendente dal sesso, non chiediamo. Web mostra solo maschile finché non cambiamo libreria; mobile rispetta entrambe.",
    "figure_masculine": "Maschile",
    "figure_feminine": "Femminile",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Profilo salvato.",
    "agePrefix_under_18": "Meno di 18",
    "age_18-24": "18-24",
    "age_25-29": "25-29",
    "age_30-34": "30-34",
    "age_35-39": "35-39",
    "age_40-44": "40-44",
    "age_45-49": "45-49",
    "age_50-54": "50-54",
    "age_55-59": "55-59",
    "age_60-64": "60-64",
    "age_65-69": "65-69",
    "age_70-plus": "70+",
    "bodyweight": "Peso corporeo (facoltativo)",
    "bodyweightPlaceholder": "es. 78",
    "bodyweightHelp": "Serve solo a calcolare il carico effettivo negli esercizi a corpo libero. Mai aggregato, mai nei log, cancellato con l'account.",
    "errBodyweight": "Inserisci un peso tra 20 e 300 kg (o l'equivalente in lb).",
    "apk": {
      "title": "APK Android (build di test)",
      "hint": "Build di test ad uso famiglia. Su Android abilita «Installa da app sconosciute» nel browser, poi apri il file.",
      "download": "Scarica APK"
    },
    "email": "Email",
    "metaTitle": "Sessione"
  },
  "workout": {
    "title": "Allenamenti",
    "loading": "Caricamento allenamenti…",
    "empty": "Nessun allenamento registrato.",
    "logNew": "Registra allenamento",
    "startedAt": "Quando",
    "exercise": "Esercizio",
    "exercisePlaceholder": "Scegli un esercizio",
    "errPickExercise": "Scegli un esercizio dal catalogo.",
    "catalogEmptyCoach": "Il catalogo è vuoto. Aggiungi almeno un esercizio prima di registrare un allenamento.",
    "catalogEmptyAthlete": "Il catalogo è vuoto. Uno dei tuoi coach deve aggiungere gli esercizi prima che tu possa registrare un allenamento.",
    "setsLegend": "Serie",
    "set": "Serie",
    "reps": "Ripetizioni",
    "amrapHint": "AMRAP — supera il floor prescritto",
    "weight": "Peso",
    "extra": "Extra (+/−)",
    "unit": "Unità",
    "rpe": "RPE",
    "addSet": "Aggiungi serie",
    "removeSet": "Rimuovi serie",
    "notes": "Note (facoltative)",
    "setNoteToggle": "Aggiungi una nota a questa serie",
    "setNotePlaceholder": "Cosa è cambiato in questa serie",
    "draftRecoveryHeadline": "Hai un allenamento non finito del {{when}}.",
    "draftRecoveryContinue": "Continua",
    "draftRecoveryDiscard": "Scarta",
    "maxBumpAvailable": "{{exercise}}: nuovo MAX a {{value}}",
    "maxBumpConfirm": "↑ Conferma",
    "maxBumpSaving": "Salvataggio…",
    "prefillFromDate": "Pre-compila da {{date}}?",
    "prefillAccept": "Usa",
    "prefillDismiss": "Salta",
    "savePromptTitle": "Verifica prima di salvare",
    "savePromptContinue": "Torna al workout",
    "savePromptAnyway": "Salva comunque",
    "unmarkedPromptBody": "{{count}} serie con valori ma senza marcatura.",
    "unmarkedPromptFail": "Marca come fallite e salva",
    "unmarkedPromptComplete": "Marca come fatte e salva",
    "outlierPromptBody": "{{count}} voci sembrano anomale:",
    "outlierItem": "{{exercise}}: {{weight}} (max storico {{expected}})",
    "outlierE1rmItem": "{{exercise}}: 1RM stimato {{e1rm}} (max storico {{expected}})",
    "outlierPerImplementItem": "{{exercise}}: {{weight}} è circa il doppio del tuo solito {{expected}} — hai inserito il peso di UN solo attrezzo o il totale dei due?",
    "outlierRepsItem": "{{exercise}}: {{reps}} ripetizioni — sembrano troppe",
    "outlierZeroWeightItem": "{{exercise}}: {{reps}} ripetizioni senza peso",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Allenamento salvato.",
    "savedEdit": "Allenamento aggiornato.",
    "savedEditOldRemains": "Allenamento aggiornato, ma la versione precedente è ancora nello storico. Eliminala a mano.",
    "deleted": "Allenamento eliminato.",
    "cancel": "Annulla",
    "errNoSets": "Aggiungi almeno una serie valida.",
    "creatingTitle": "Nuovo allenamento",
    "editingTitle": "Modifica allenamento",
    "exerciseN": "Esercizio {{n}}",
    "addExercise": "Aggiungi un altro esercizio",
    "removeExercise": "Rimuovi esercizio",
    "removeExerciseConfirm": "Rimuovere {{name}} da questo allenamento? Le serie già registrate andranno perse.",
    "groupAlignTitle": "Numero di serie diverso",
    "groupAlignBody": "I membri di questo gruppo hanno tra {{shortest}} e {{longest}} serie. Allinearli per far quadrare i giri?",
    "groupAlignPad": "+ Allunga a {{n}}",
    "groupAlignTrim": "− Accorcia a {{n}}",
    "groupAlignTrimWarning": "Accorciare cancella serie già registrate, e non si torna indietro.",
    "groupAlignTrimHint": "Cancella le serie in eccesso da ogni membro del gruppo. Non si torna indietro.",
    "groupAlignKeep": "Mantieni così",
    "splitGroup": "Sciogli",
    "splitGroupTitle": "Sciogliere il gruppo?",
    "splitGroupBody": "I membri mantengono le loro serie e restano nel workout, solo non più collegati. Puoi riformare il gruppo quando vuoi.",
    "splitGroupConfirm": "Sciogli",
    "removeRoundConfirmTitle": "Rimuovere questo giro?",
    "removeRoundConfirmBody": "Il giro {{n}} di {{names}} verrà eliminato insieme.",
    "bilateral": "Bilaterale",
    "unilateral": "Unilaterale",
    "edit": "Modifica",
    "repeat": "Ripeti",
    "delete": "Elimina",
    "deleting": "Eliminazione…",
    "deleteConfirm": "Eliminare questo allenamento?",
    "distance": "m",
    "duration": "s",
    "cardioDuration": "Durata",
    "cardioDistance": "Distanza",
    "cardioWeight": "Peso",
    "cardioHr": "FC media",
    "cardioCalories": "Calorie",
    "cardioOptionalsShow": "Altri campi",
    "cardioOptionalsHide": "Altri campi",
    "dateEditor": "Data e durata",
    "dateLabel": "Data",
    "startTimeLabel": "Inizio",
    "endTimeLabel": "Fine",
    "durationLabel": "Durata",
    "side": "Lato",
    "sideLeft": "Sinistro",
    "sideRight": "Destro",
    "sideBoth": "Entrambi",
    "showRpe": "Mostra RPE",
    "showDuration": "Mostra durata",
    "rir": "RIR {{n}}",
    "swap": "Cambia",
    "swapHint": "Panca occupata? Scegli un esercizio simile.",
    "descriptionToggle": "Mostra / nascondi descrizione",
    "failShort": "F",
    "failToggle": "Segna la serie come fallita",
    "failHint": "Ultima rep non chiusa. Conta nel volume, esclusa dai PR.",
    "startRest": "Avvia il timer di recupero",
    "restStartDefault": "Avvia recupero ({{n}}s)",
    "restStartCustom": "Avvia recupero ({{n}}s, default dell'esercizio)",
    "setComplete": "Segna la serie come fatta",
    "setCompleteHint": "Timbra la serie e parte il recupero da {{n}}s.",
    "setCompleteHintCustom": "Timbra la serie e parte il recupero da {{n}}s (default dell'esercizio).",
    "setUndo": "Annulla il completamento",
    "setUndoHint": "Tocca di nuovo per annullare e resettare il recupero.",
    "restLeft": "Recupero",
    "restDone": "Tempo scaduto",
    "restStop": "Stop",
    "restPause": "Pausa",
    "restResume": "Riprendi",
    "restSound": "Bip a fine recupero",
    "instructions": "Indicazioni del coach (opzionale)",
    "instructionsPlaceholder": "Focus della sessione, cosa saltare se manca tempo, intento.",
    "lastTime": "Ultima",
    "lastToday": "oggi",
    "lastDaysAgo": "{{n}}g fa",
    "dropsetShort": "Drop",
    "dropsetToggle": "Aggiungi catena dropset",
    "dropsetHint": "Aggancia altre rep alla serie senza recupero.",
    "dropsetTitle": "Dropset",
    "dropsetVariant": "Variante",
    "dropsetClassical": "Classico (peso scende)",
    "dropsetMyorep": "Myo-rep (stesso peso)",
    "dropsetHintClassical": "Cala il carico del 10–30% e chiudi a cedimento. Niente pausa.",
    "dropsetHintMyorep": "Stesso peso, meno reps, 10–20s di respiro, ripeti.",
    "dropsetSameLoad": "= sopra",
    "dropsetAddStep": "Aggiungi drop",
    "dropsetRemove": "Rimuovi",
    "dropsetRemoveConfirm": "Hai {{n}} drop step. Convertire di nuovo in working set e scartarli?",
    "dropsetRemoveStep": "Rimuovi drop",
    "groupLabel": "Gruppo",
    "groupNone": "(nessuno)",
    "groupCreate": "Crea nuovo",
    "groupNewSuperset": "Nuovo superset",
    "groupNewCircuit": "Nuovo circuit",
    "groupJoinExisting": "Unisci a un gruppo esistente",
    "groupLeave": "Sciogli",
    "groupSharedHint": "Condiviso. Apri un altro esercizio e seleziona lo stesso gruppo dalla tendina per accoppiarli.",
    "supersetN": "Superset {{n}}",
    "circuitN": "Circuit {{n}}",
    "supersetDerived": "Superset (auto)",
    "supersetDerivedTitle": "Rilevato dall'alternanza dei set in questa sessione",
    "playActiveTitle": "Esercizio attivo — set completato più di recente",
    "errGroupKindMixed": "Un gruppo non può mischiare superset e circuit. Scegli un solo tipo.",
    "exerciseNew": "Nuovo esercizio",
    "cardMenu": "Opzioni esercizio",
    "menuReplace": "Sostituisci esercizio",
    "menuGroup": "Gruppo / superset",
    "menuMoveUp": "Sposta su",
    "menuMoveDown": "Sposta giù",
    "menuShowNotes": "Mostra note",
    "menuHideNotes": "Nascondi note",
    "menuShowDescription": "Mostra descrizione",
    "menuHideDescription": "Nascondi descrizione",
    "tipAlternatives": "Esercizi alternativi",
    "tipCoachNote": "Nota del coach",
    "perImplementHint": "Ne usi due, o un lato per volta? Scrivi il peso di uno solo. L'app conta entrambi (×2).",
    "tipProgramNote": "In questo programma",
    "tipNoAlternatives": "Nessun esercizio simile in catalogo",
    "tipClose": "Chiudi",
    "painBanner": {
      "red": "Sollecita un muscolo dolorante",
      "yellow": "Attenzione: carica un muscolo segnalato",
      "green": "Nessun rischio segnalato"
    },
    "setCycleHint": "Tap: chiusa · ancora: fallita · ancora: annulla",
    "setStatePending": "Serie aperta",
    "setStateDone": "Serie chiusa",
    "setStatePr": "Serie chiusa, record personale",
    "setStateFailed": "Serie segnata come fallita",
    "prShort": "🏆",
    "addDrop": "+ drop",
    "groupBannerSuperset": "SUPERSET",
    "groupBannerCircuit": "CIRCUIT",
    "groupAutoTag": "AUTO",
    "groupAutoConfirm": "Conferma",
    "groupAutoConfirmAria": "Blocca il gruppo: termina la rilevazione e tieni gli esercizi raggruppati",
    "groupAutoDismiss": "Sciogli",
    "groupAutoDismissAria": "Ignora la rilevazione: gli esercizi tornano a essere singoli",
    "groupAddSetAll": "Aggiungi serie a tutti",
    "nameLabel": "Nome (opzionale)",
    "namePlaceholder": "Es. Push A · Lower Quad-Dominant",
    "durationStepperA11y": "stepper durata",
    "rirLabel": "RIR",
    "showRir": "Mostra RIR",
    "maxDownA11y": "Il MAX potrebbe essere sceso",
    "animationOf": "Animazione di {{name}}",
    "animationZoomHint": "Apre l'animazione a tutto schermo",
    "closeAnimation": "Chiudi l'animazione",
    "showAnimation": "Mostra l'animazione",
    "showBodyMap": "Mostra i muscoli coinvolti",
    "pageOf": "{{current}} di {{total}}",
    "pagerDot": "{{target}}, {{current}} di {{total}}"
  },
  "program": {
    "title": "Programmi",
    "help": "Cicli di allenamento multi-settimana. La fase 5.1 spedisce lo scheletro: nome, settimane, sessioni per settimana. Il builder di slot e progressione arriva nella prossima fase.",
    "new": "Nuovo programma",
    "newTitle": "Nuovo programma",
    "name": "Nome",
    "namePlaceholder": "es. Powerbuilding 6 settimane",
    "cycleWeeks": "Settimane del ciclo",
    "sessionsPerWeek": "Sessioni a settimana",
    "description": "Descrizione",
    "descriptionPlaceholder": "A cosa serve il ciclo, a chi è rivolto, eventuali note per gli atleti.",
    "create": "Crea",
    "creating": "Nuovo programma: {{name}}",
    "cancel": "Annulla",
    "delete": "Elimina",
    "deleteConfirm": "Confermi?",
    "deleteConfirmYes": "Sì, elimina",
    "loading": "Caricamento programmi…",
    "empty": "Nessun programma ancora. Creane uno per pianificare un ciclo multi-settimana.",
    "statusDraft": "Bozza",
    "statusActive": "Attivo",
    "statusArchived": "Archiviato",
    "cycleWeeksLabel": "Ciclo di {{n}} settimane",
    "sessionsPerWeekLabel": "{{n}}× / settimana",
    "slotCount": "{{n}} slot",
    "skeletonHint": "Solo scheletro. Gli slot si riempiono nella prossima fase.",
    "sessionDefaultName": "Sessione {{n}}",
    "edit": "Modifica",
    "editing": "Modifica: {{name}}",
    "backToList": "Torna ai programmi",
    "save": "Salva",
    "saving": "Salvataggio…",
    "errSave": "Impossibile salvare il programma.",
    "metaLegend": "Programma",
    "status": "Stato",
    "metaCyclesLive": "Le modifiche strutturali (giorni, settimane) si applicano subito",
    "ordinalSession": "{{n}}ª sessione",
    "sessionName": "Nome sessione",
    "slotN": "Slot {{n}}",
    "addSlot": "Aggiungi slot",
    "removeSlot": "Elimina",
    "moveUp": "Sposta su",
    "moveDown": "Sposta giù",
    "exercise": "Esercizio",
    "exercisePick": "Scegli un esercizio",
    "setsLegend": "Set",
    "addSet": "Aggiungi set",
    "removeSet": "Elimina set",
    "reps": "Reps",
    "setNotesPlaceholder": "Nota per il set (opzionale)",
    "set": "Set",
    "intensityKind": "Intensità",
    "intensityNone": "Libera",
    "intensityPercent": "% del MAX",
    "intensityAbs": "kg (assoluti)",
    "intensityRpe": "RPE",
    "intensity_percent-of-max": "Percentuale",
    "intensity_absolute": "Peso (kg)",
    "intensity_rpe": "RPE",
    "weekShort": "S{{n}}",
    "previewShow": "Anteprima",
    "previewHide": "Nascondi anteprima",
    "previewMuscles": "Muscoli coinvolti",
    "previewSets": "{{n}} set",
    "previewEmptySession": "Nessuno slot in questa sessione.",
    "previewEmptyProgram": "Nessuno slot ancora. Apri Modifica per aggiungerli.",
    "start": "Avvia sessione",
    "startCancel": "Annulla",
    "startGo": "Avvia",
    "starting": "Avvio in corso…",
    "startWeek": "Settimana",
    "startSession": "Sessione",
    "progressNext": "Prossima: S{{w}} · Sessione {{s}}",
    "instructions": "Istruzioni",
    "instructionsPlaceholder": "Tempo, durata pausa, focus tecnico, RPE target.",
    "amrapLastSet": "AMRAP sull'ultimo set",
    "maxAttempt": "Tentativo 1MAX",
    "amrapBadge": "AMRAP",
    "maxBadge": "1MAX",
    "slotCycleHint": "Applicato sulle {{n}} settimane del ciclo.",
    "catalogLoading": "Caricamento del catalogo esercizi…",
    "builderComingSoon": "Il builder di slot e progressione arriva con la fase 5.2. Per ora questo crea uno scheletro vuoto, eliminabile o riempibile dopo.",
    "errCycleWeeks": "Le settimane devono essere tra 1 e 12.",
    "errSessionsPerWeek": "Le sessioni a settimana devono essere tra 1 e 7.",
    "errName": "Il nome del programma è obbligatorio.",
    "errEmptyDay": "Ogni giorno di allenamento deve avere almeno un esercizio.",
    "errSchema": "Dati del programma non validi.",
    "errCreate": "Impossibile creare il programma.",
    "errCode": {
      "sessionNameEmpty": "Ogni giorno di allenamento deve avere un nome.",
      "slotNoExercise": "Scegli un esercizio per ogni slot.",
      "slotNoSets": "Ogni esercizio deve avere almeno una serie.",
      "slotAllWeeksInactive": "Un esercizio è disattivato in tutte le settimane. Attiva una settimana o rimuovilo.",
      "rowWidthMismatch": "Una riga di serie non corrisponde al numero di settimane. Riapri l'esercizio e riprova.",
      "invalidReps": "Controlla le ripetizioni: usa un numero come 8, oppure 8+ per l'AMRAP.",
      "groupKindMixed": "Un superset mescola tipi di serie diversi. Dai lo stesso tipo ai suoi esercizi.",
      "schemaInvalid": "Dati del programma non validi.",
      "noSession": "Non c'è nessun allenamento da salvare.",
      "planNameEmpty": "Il nome del piano è obbligatorio.",
      "planNoExercises": "Aggiungi almeno un esercizio al piano.",
      "invalidIntensityValue": "Controlla il valore di intensità: deve essere un numero.",
      "weightOutOfRange": "Questo peso è fuori intervallo.",
      "pctOutOfRange": "La percentuale deve essere tra 0 e 200.",
      "rpeOutOfRange": "L'RPE deve essere tra 1 e 10.",
      "rirOutOfRange": "Il RIR deve essere tra 0 e 10.",
      "unknownIntensityKind": "Tipo di intensità sconosciuto.",
      "invalidSeconds": "Controlla i secondi: un set a tempo vuole una durata, in secondi interi fino a 3600."
    },
    "cardMenu": "Menù slot",
    "menuGroup": "Gruppo",
    "groupNone": "Nessun gruppo",
    "groupJoinExisting": "Aggiungi a un gruppo",
    "groupCreate": "Crea",
    "groupNewSuperset": "Nuovo superset",
    "groupNewCircuit": "Nuovo circuito",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuito {{letter}}",
    "assignTo": "Assegna agli atleti",
    "assignToHelp": "Il programma viene aggiunto alla libreria di ogni atleta. Serve un coach edge attivo con te.",
    "assignSelf": "Tu (autore)",
    "addAssignee": "Aggiungi",
    "removeAssignee": "Rimuovi",
    "assigneePlaceholder": "atleta@esempio.com",
    "follow": "Segui",
    "unfollow": "Non seguire",
    "followHint": "Segui questo programma (compare in In corso)",
    "publish": "Pubblica",
    "unpublish": "Riporta a bozza",
    "publishAndFollow": "Pubblica e segui",
    "publishHint": "Rendi questo programma disponibile da seguire",
    "chipDraft": "Bozza",
    "chipPublished": "Pubblicato",
    "chipFollowed": "Seguito",
    "kindShortAbsolute": "KG",
    "kindShortAbsoluteLb": "LB",
    "kindShortPercent": "%MAX",
    "kindShortHistory": "STOR",
    "kindShortRpe": "RPE",
    "kindShortRir": "RIR",
    "languageUndeclared": "Lingua",
    "languageA11y": "Lingua di scrittura",
    "languageSwitchQuestion": "In che lingua stai scrivendo?",
    "languageDeclareQuestion": "In che lingua è scritto questo programma?",
    "languageFootnote": "Le traduzioni sono facoltative: un programma in una lingua sola è completo.",
    "languageDeclareFootnote": "Non traduce niente: indica soltanto la lingua.",
    "languageAuto": "Traduzione automatica",
    "languageNotYetWritten": "Manca ancora la versione in {{lang}}. Il testo in {{original}} resta al suo posto.",
    "setBound": "Limite",
    "boundReps": "Reps",
    "boundTime": "Tempo",
    "boundOpen": "Libero",
    "workSeconds": "Lavoro (s)",
    "restSeconds": "Recupero (s)",
    "restSecondsPlaceholder": "auto",
    "prescribeTime": "Tempo",
    "prescribeTimeA11y": "Prescrivi lavoro e recupero in secondi",
    "seconds": "Secondi",
    "amrapNotWithTime": "Un set da {{secs}}s non può essere anche AMRAP: un piano non può chiedere quante ne farai. Togli il + o il tempo.",
    "workSecondsRequired": "Quanto dura?"
  },
  "me": {
    "targets": {
      "title": "Obiettivi",
      "historyByCoach": "Il tuo coach",
      "errNotFound": "Impossibile trovare i tuoi obiettivi. Torna indietro e riprova."
    }
  },
  "coach": {
    "title": "Coach e atleti",
    "subtitle": "Atleti che alleni e coach che ti allenano. L'invito richiede il consenso di entrambe le parti prima che gli assegnamenti possano fluire.",
    "subLabel": "sub",
    "inviteAthleteLabel": "Invita un atleta via email",
    "invitePlaceholder": "atleta@esempio.com",
    "inviteNotePlaceholder": "Nota (facoltativa)",
    "inviteSend": "Manda invito",
    "inviteSending": "Invio…",
    "inviteSent": "Invito mandato. L'atleta lo vede al prossimo accesso.",
    "athletesHeading": "Atleti che alleno",
    "coachesHeading": "Coach che mi allenano",
    "athletesEmpty": "Nessun atleta. Inviane uno qui sopra.",
    "pendingInLabel": "In attesa di risposta tua",
    "pendingOutLabel": "In attesa di risposta loro",
    "activeLabel": "Attivi",
    "accept": "Accetta",
    "decline": "Rifiuta",
    "cancel": "Annulla invito",
    "revoke": "Revoca",
    "leave": "Lascia coach",
    "busy": "In corso…",
    "loading": "Carico…",
    "loadFailed": "Caricamento fallito. Ricarica per riprovare.",
    "errCode": {
      "invalid_email": "Email malformata.",
      "email_not_found": "Nessun account verificato con quell'email.",
      "peer_required": "Indica un'email o un sub.",
      "edge_exists": "Esiste già un edge con questo peer.",
      "userpool_not_configured": "Server malconfigurato: user pool non disponibile.",
      "io_error": "Errore di rete o server. Riprova.",
      "not_pending": "Questo invito non è più in attesa.",
      "wrong_party": "Solo l'altra parte può accettare questo invito."
    },
    "dashboard": {
      "title": "Panoramica squadra",
      "unnamedAthlete": "Atleta",
      "empty": "Ancora nessun atleta",
      "emptySub": "Invita atleti da Coach e atleti per vederli qui.",
      "loading": "Carico la tua squadra…",
      "loadFailed": "Impossibile caricare la squadra. Aggiorna per riprovare.",
      "noProgram": "Nessun programma",
      "kpiAssigned": "Atleti",
      "kpiActive": "Attivi questa settimana",
      "kpiAttention": "Richiedono attenzione",
      "kpiAdherence": "Aderenza media",
      "kpiSessions": "Sessioni questa settimana",
      "adherence": "aderenza",
      "lastToday": "oggi",
      "lastNever": "mai allenato",
      "lastDaysAgo": "{{count}}g fa",
      "flagStale": "Non si allena",
      "flagUnderTarget": "Sotto target",
      "flagOnTrack": "In linea",
      "flagNoProgram": "Nessun programma"
    },
    "detail": {
      "back": "Torna alla squadra",
      "maxesTitle": "MAX attuali",
      "maxesEmpty": "Nessun MAX registrato",
      "rhythmSummary": "media {{avg}}/settimana su {{weeks}} settimane · ultima settimana: {{last}}",
      "effortTitle": "Copertura effort",
      "effortLabel": "serie con RIR registrato",
      "effortSummary": "{{tagged}} serie su {{counted}} conteggiate, riscaldamenti inclusi",
      "effortEra": "I dati effort partono dal {{date}} · {{count}} serie precedenti non sono conteggiate",
      "effortNone": "Nessuna serie porta ancora un valore di effort: i numeri su hard set e target non hanno su cosa poggiare.",
      "effortError": "Impossibile caricare i dati effort.",
      "maxesSeeAll": "Mostra tutti (+{{count}})",
      "maxesShowFewer": "Mostra meno"
    },
    "targets": {
      "eyebrow": "Obiettivi settimanali",
      "edit": "Modifica obiettivi",
      "degradedHint": "Questo atleta non ha ancora obiettivi settimanali. Impostane qualcuno per valutare la sua settimana rispetto a un traguardo.",
      "noGrant": "Sola lettura — l'atleta non ti ha concesso la modifica degli obiettivi.",
      "historyTitle": "Cronologia modifiche",
      "historyEmpty": "Ancora nessuna modifica.",
      "historyByYou": "Tu",
      "historyTruncated": "Mostro le 1000 modifiche più recenti.",
      "histGeneric": "Obiettivi aggiornati",
      "histSet": "impostato a {{value}}",
      "histRemoved": "rimosso",
      "histChanged": "{{from}} → {{to}}",
      "histLine": "{{label}} · {{metric}}: {{body}}",
      "historyLoading": "Caricamento…",
      "errLoad": "Impossibile caricare questi obiettivi. Torna indietro e riprova.",
      "errStale": "Questi obiettivi sono cambiati mentre li modificavi. Ricarica e riapplica.",
      "errNoGrant": "L'atleta non ti ha concesso la modifica degli obiettivi.",
      "errNotCoach": "Non sei il coach di questo atleta.",
      "errMultiAssignee": "Questo programma è condiviso da più di un atleta.",
      "errRetry": "Ancora in caricamento — riprova tra un istante.",
      "errNotFound": "Questo programma non esiste più.",
      "errOffline": "Salvataggio non riuscito. Controlla la connessione e riprova."
    }
  },
  "plans": {
    "title": "Piani",
    "help": "Prepara un allenamento per te stesso. I target possono essere in kg assoluti o in percentuale del MAX, convertiti in kg quando avvii il piano.",
    "loading": "Caricamento piani…",
    "empty": "Nessun piano ancora. Aggiungine uno per preparare la sessione.",
    "todayPill": "Oggi",
    "add": "Aggiungi piano",
    "edit": "Modifica",
    "start": "Avvia",
    "cancel": "Annulla",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Piano salvato.",
    "savedEdit": "Piano aggiornato.",
    "deleted": "Piano eliminato.",
    "delete": "Elimina",
    "deleting": "Eliminazione…",
    "deleteConfirm": "Eliminare questo piano?",
    "creatingTitle": "Nuovo piano",
    "editingTitle": "Modifica piano",
    "name": "Nome",
    "namePlaceholder": "es. Giorno squat",
    "scheduledFor": "Data prevista (opzionale)",
    "pickDate": "Scegli una data",
    "pickDateHint": "Apre il selettore di data",
    "clearDate": "Cancella la data",
    "noDate": "Non impostata",
    "notes": "Note (opzionale)",
    "rpeEnabledLabel": "Mostra colonna RPE nel Logger",
    "rpeEnabledHelp": "Quando attivo, le sessioni avviate da questo piano si aprono con la colonna RPE visibile. L'atleta può comunque modificarla a sessione.",
    "exercise": "Esercizio",
    "exercisePlaceholder": "Scegli un esercizio",
    "exerciseN": "Esercizio {{n}}",
    "removeExercise": "Rimuovi esercizio",
    "addExercise": "Aggiungi un altro esercizio",
    "setsLegend": "Serie",
    "targetReps": "Reps",
    "targetWeight": "Peso",
    "targetKind": "Unità",
    "targetRpe": "RPE",
    "noMaxYet": "nessun MAX",
    "addSet": "Aggiungi serie",
    "removeSet": "Rimuovi serie",
    "statusDraft": "Bozza",
    "statusScheduled": "Pianificato",
    "statusCompleted": "Completato",
    "statusSkipped": "Saltato",
    "errNotSignedIn": "Serve l'accesso.",
    "errNameRequired": "Dai un nome al piano.",
    "errPickExercise": "Scegli un esercizio dal catalogo.",
    "errNoSets": "Aggiungi almeno una serie valida.",
    "errGroupKindMixed": "Due esercizi hanno lo stesso group id ma uno è superset e l'altro circuito. Scegli un tipo e salva.",
    "assignTo": "Assegna anche a",
    "assignToHelp": "Scrivi un'email e premi Invio. L'indirizzo deve già avere un account, altrimenti il piano viene rifiutato.",
    "addAssignee": "Aggiungi",
    "removeAssignee": "Rimuovi",
    "assigneePlaceholder": "nome@esempio.com",
    "exerciseNew": "Scegli un esercizio",
    "setIndex": "Serie {{n}}",
    "cardMenu": "Menù scheda",
    "menuGroup": "Gruppo",
    "menuMoveUp": "Sposta su",
    "menuMoveDown": "Sposta giù",
    "groupNone": "Nessun gruppo",
    "groupJoinExisting": "Aggiungi a un gruppo",
    "groupCreate": "Crea",
    "groupNewSuperset": "Nuovo superset",
    "groupNewCircuit": "Nuovo circuito",
    "groupSupersetN": "Superset {{letter}}",
    "groupCircuitN": "Circuito {{letter}}",
    "details": "Dettagli",
    "exercisesLabel": "Esercizi",
    "editorEmpty": "Nessun esercizio. Aggiungine uno per iniziare a costruire questo piano.",
    "selectExercisePrompt": "Seleziona un esercizio per modificarne le serie.",
    "addExerciseCta": "Aggiungi esercizio",
    "removeExerciseConfirm": "Rimuovere questo esercizio?",
    "removeExerciseHint": "Tocca una volta per confermare, poi tocca di nuovo per rimuovere.",
    "collapseExercise": "Comprimi esercizio",
    "supersetTag": "SUPERSET",
    "exerciseNoteLabel": "Nota esercizio (opzionale)"
  },
  "templates": {
    "show": "Sfoglia i template di partenza",
    "hide": "Nascondi i template",
    "help": "Piani e programmi comuni pronti all'uso. Clonane uno nel tuo account — la copia è tua, modificala o cancellala senza toccare il template.",
    "loading": "Caricamento template…",
    "empty": "Nessun template disponibile al momento.",
    "errLoad": "Impossibile caricare i template.",
    "clone": "Clona nei miei",
    "cloning": "Clonazione…",
    "cloned": "Clonato \"{{name}}\".",
    "alreadyCloned": "Già clonato",
    "difficultyBeginner": "Principiante",
    "difficultyIntermediate": "Intermedio",
    "difficultyAdvanced": "Avanzato",
    "planMeta": "{{n}} esercizio/i",
    "programMeta": "Ciclo di {{weeks}} settimane · {{sessions}}× / settimana"
  },
  "maxes": {
    "title": "Massimali",
    "countLabel_one": "{{count}} impostato",
    "countLabel_other": "{{count}} impostati",
    "help": "Il MAX è quello che puoi alzare oggi, impostato da te. I programmi lo usano come base per le percentuali. Il massimale stimato nel grafico Andamento è solo informativo.",
    "loading": "Caricamento massimali…",
    "empty": "Nessun massimale impostato. Aggiungine uno per guidare la programmazione a percentuale.",
    "add": "Aggiungi massimale",
    "edit": "Modifica",
    "delete": "Elimina",
    "deleteAction": "Elimina MAX",
    "deleting": "Eliminazione…",
    "deleted": "MAX eliminato.",
    "deleteConfirm": "Eliminare il MAX di {{name}}? Anche lo storico viene rimosso. Un prossimo seed dallo storico potrà ripopolarlo dai tuoi allenamenti.",
    "exercise": "Esercizio",
    "exercisePlaceholder": "Scegli un esercizio",
    "value": "Valore",
    "source": "Origine",
    "sourceManual": "Impostato a mano",
    "sourceTested": "Testato in palestra",
    "sourceDerived": "Derivato da una serie loggata",
    "sourceCalculated": "Stimato dalla storia",
    "sourceImported": "Importato",
    "notes": "Note (facoltative)",
    "save": "Salva",
    "saving": "Salvataggio…",
    "saved": "Massimale salvato.",
    "cancel": "Annulla",
    "errPickExercise": "Scegli un esercizio.",
    "errInvalidValue": "Inserisci un valore tra 0 e 2000.",
    "seed": {
      "start": "Suggerisci dallo storico",
      "loading": "Lettura dello storico in corso…",
      "reviewIntro": "{{count}} esercizi hanno una serie top credibile nello storico. Seleziona quali usare come MAX. Gli esercizi che hanno già un MAX vengono saltati.",
      "selectAll": "Seleziona tutto",
      "selectNone": "Deseleziona tutto",
      "fromSet": "da {{weight}} × {{reps}}",
      "cancel": "Annulla",
      "apply": "Imposta {{count}} MAX",
      "applying": "Salvataggio: {{done}} / {{total}}",
      "applied": "Impostati {{count}} MAX dallo storico.",
      "noneApplicable": "Nulla da impostare. O ogni esercizio ha già un MAX, o non è stato trovato storico pesato.",
      "close": "Chiudi"
    }
  },
  "progress": {
    "coverageTitle": "Copertura muscolare",
    "coverageSubtitle": "vs target settimanale",
    "coverageTopTrained": "I tuoi muscoli più allenati questa settimana.",
    "coverageLead": "Sotto il target settimanale: {{count}}",
    "coverageAllGood": "Ogni muscolo a target questa settimana.",
    "coverageAvg": "media {{n}}/sett",
    "coverageSeeAll": "Vedi tutti i muscoli (+{{count}})",
    "coverageShowFewer": "Mostra meno",
    "detailsTitle": "Più dettagli",
    "detailsSubtitle": "Analisi di allenamento approfondite",
    "period": {
      "days": "{{days}} g",
      "painDays": "7 / {{days}} g",
      "selectorLabel": "Finestra di analisi"
    },
    "title": "Andamento",
    "show": "Mostra",
    "hide": "Nascondi",
    "help": "Il MAX è il valore che imposti tu; il massimale stimato usa Epley come riferimento. Il volume è la somma di peso per ripetizioni della seduta.",
    "e1rm": "Massimale stimato",
    "max": "MAX",
    "maxLabel": "MAX",
    "estimatedBadge": "1RM stimato tratteggiato",
    "volume": "Volume",
    "sessions": "{{n}} sedute",
    "prFound": "Record personale a {{weight}}.",
    "prUpdate": "Aggiorna MAX a {{weight}}",
    "prUpdating": "Aggiornamento…",
    "viewByExercise": "Per esercizio",
    "viewByTag": "Per tag",
    "noTags": "Nessuna seduta taggata ancora. Tagga gli esercizi nel catalogo per vedere il volume aggregato qui.",
    "totalVolume": "Totale {{weight}}",
    "recordsScope": "Record",
    "recordsAllTime": "Tutti",
    "recordsThisYear": "{{year}}",
    "filterPlaceholder": "Filtra esercizi",
    "filterCount": "{{visible}} su {{total}}",
    "filterNoMatch": "Nessun esercizio corrisponde al filtro.",
    "coverageNoData": "Ancora niente da valutare: registra una seduta, o imposta un target settimanale."
  },
  "cohort": {
    "compare": "Confronta col gruppo (anonimo)",
    "hide": "Nascondi confronto",
    "loading": "Caricamento dati gruppo…",
    "empty": "Per ora non ci sono abbastanza contributi per mostrare un confronto. La soglia è dieci persone nella stessa fascia d'età.",
    "contributors": "Basato su {{n}} contributi anonimi con fascia d'età indicata.",
    "yourGroup": "il tuo gruppo"
  },
  "catalog": {
    "title": "Catalogo esercizi",
    "loading": "Caricamento…",
    "empty": "Nessun esercizio.",
    "seedStarter": "Carica set iniziale",
    "seeding": "Caricamento…",
    "importTaxonomy": "Importa la libreria esercizi completa",
    "importTaxonomyUpsert": "Aggiorna dalla libreria esercizi",
    "importing": "Importazione…",
    "importDone": "Importazione conclusa. Creati {{created}}, aggiornati {{upserted}}, saltati {{skipped}}, falliti {{failed}}.",
    "add": "Aggiungi esercizio",
    "edit": "Modifica",
    "cancel": "Annulla",
    "save": "Salva",
    "create": "Crea",
    "saving": "Salvataggio…",
    "name": "Nome",
    "namePlaceholder": "es. Squat con bilanciere",
    "primaryMuscle": "Muscolo principale (facoltativo)",
    "primaryMusclePlaceholder": "es. quadricipiti",
    "primaryLabel": "Muscoli primari (almeno uno)",
    "secondaryLabel": "Muscoli secondari (facoltativo)",
    "addMuscle": "+ Aggiungi muscolo",
    "removeMuscle": "Rimuovi muscolo",
    "errPrimaryRequired": "Scegli almeno un muscolo primario.",
    "isBodyweight": "Esercizio a corpo libero",
    "isBodyweightHelp": "Le serie registrano ripetizioni e un eventuale carico aggiuntivo, non un peso al bilanciere.",
    "hasP1RM": "Programmabile in percentuale del MAX",
    "hasP1RMHelp": "Permette ai piani di impostare un obiettivo come frazione del MAX per questo esercizio.",
    "defaultRest": "Recupero predefinito (s)",
    "defaultRestPlaceholder": "es. 180",
    "defaultRestHelp": "Secondi del timer di recupero per default. Lascia vuoto per usare quello dell'app (90s).",
    "defaultBar": "Peso bilanciere specifico (kg)",
    "defaultBarPlaceholder": "es. 7",
    "defaultBarHelp": "Curl bar 7, trap bar 11, landmine ~10. Il calcolatore dischi parte da questo valore quando apri un set di questo esercizio. Vuoto = default del menù.",
    "pinnedNoteLabel": "Cue di setup (facoltativo)",
    "pinnedNotePlaceholder": "es. Altezza rack 4, fermi 6, pausa 1s",
    "pinnedNoteHelp": "Mostrato come banner sotto il titolo dell'esercizio nel Logger. Note a livello di piano o slot di programma, quando presenti, hanno la precedenza.",
    "noMuscle": "-",
    "bw": "BW",
    "p1rm": "1RM%",
    "errSlug": "Usa lettere latine nel nome così il sistema può generare un identificatore stabile.",
    "errSlugExists": "Esiste già un esercizio con questo nome.",
    "searchPlaceholder": "Cerca esercizi…",
    "region": "Distretto",
    "regionAll": "Tutti i distretti",
    "region_lower": "Parte bassa",
    "region_posterior": "Catena posteriore",
    "region_chest": "Petto",
    "region_back": "Schiena",
    "region_shoulders": "Spalle",
    "region_arms": "Braccia",
    "region_core": "Core",
    "region_cardio": "Cardio",
    "region_other": "Altro",
    "pattern": "Pattern",
    "patternAll": "Tutti i pattern",
    "pattern_squat": "Squat",
    "pattern_hinge": "Hinge",
    "pattern_horizontal-push": "Spinta orizzontale",
    "pattern_vertical-push": "Spinta verticale",
    "pattern_horizontal-pull": "Tirata orizzontale",
    "pattern_vertical-pull": "Tirata verticale",
    "pattern_lunge": "Affondo",
    "pattern_carry": "Carry",
    "pattern_core": "Core",
    "pattern_isolation": "Isolamento",
    "pattern_cardio": "Cardio",
    "pattern_other": "Altro",
    "equipment": "Attrezzo",
    "equipmentAll": "Tutti gli attrezzi",
    "equipment_barbell": "Bilanciere",
    "equipment_dumbbell": "Manubri",
    "equipment_kettlebell": "Kettlebell",
    "equipment_cable": "Cavi",
    "equipment_machine": "Macchina",
    "equipment_bodyweight": "Corpo libero",
    "equipment_band": "Elastico",
    "equipment_other": "Altro",
    "clearFilters": "Pulisci filtri",
    "noResults": "Nessun esercizio corrisponde a questi filtri.",
    "tags": "Tag",
    "tagsHelp": "Etichette libere per filtri e report. Scrivi uno slug e premi Invio, oppure clicca Suggerisci per partire dai campi strutturati.",
    "tagsPlaceholder": "es. compound, warmup, for-sandrine",
    "addTag": "Aggiungi",
    "removeTag": "Rimuovi tag",
    "suggestTags": "Suggerisci",
    "description": "Descrizione",
    "descriptionHelp": "Nota breve mostrata nel catalogo e come hint nel logger. Le altre lingue vengono compilate automaticamente.",
    "descriptionPlaceholder": "Setup, indicazione chiave, errore comune…",
    "descriptionResetDefault": "Reimposta al default bundle",
    "locale_en": "EN",
    "locale_it": "IT",
    "locale_fr": "FR",
    "locale_de": "DE",
    "locale_ru": "RU",
    "equipment_treadmill": "Tapis roulant",
    "equipment_exercise-bike": "Cyclette",
    "equipment_elliptical": "Ellittica",
    "equipment_rower": "Vogatore",
    "equipment_stair-climber": "Scalapendio",
    "equipment_jump-rope": "Corda per saltare",
    "equipment_battle-ropes": "Corde nautiche",
    "equipment_sled": "Slitta",
    "deletedExercise": "Esercizio cancellato"
  },
  "swap": {
    "title": "Cambia esercizio",
    "currentLabel": "Attuale",
    "searchPlaceholder": "Cerca nel catalogo…",
    "showAll": "Mostra tutti gli esercizi",
    "noMatches": "Nessun esercizio corrisponde alla ricerca.",
    "noSuggestions": "Nessun simile per tag. Spunta \"Mostra tutti\" per esplorare il catalogo.",
    "close": "Chiudi",
    "reasonTags": "Tag in comune ×{{count}}",
    "reasonPrimary": "Muscoli in comune ×{{count}}",
    "reasonDifferentEquipment": "Attrezzo diverso",
    "suggestedSection": "Suggeriti",
    "allSection": "Tutti gli esercizi",
    "whichMachine": "Quale macchina?",
    "defaultMachine": "Macchina predefinita",
    "machineLabel": "Macchina {{letter}}",
    "setMachine": "Imposta macchina",
    "machineChoices": "Macchine note: {{count}}",
    "newMachine": "Nuova macchina",
    "bandSession": "Sessione",
    "bandCurrentExercise": "Questo esercizio",
    "bandOtherExercises": "Passa a un altro esercizio",
    "equipmentKey": "Attrezzo",
    "currentConsequence": "I set già registrati restano: cambia solo l'attrezzo su cui sono segnati.",
    "unavailableTitle": "Non c'è qui?",
    "unavailableBody": "Spunta l'attrezzo di {{exercise}} che non c'è a {{place}}. Si registra solo ciò che spunti.",
    "unavailableConfirm": "Salva",
    "unavailableOpen": "Attrezzo non disponibile qui",
    "unavailableOpenHint": "Chiede quale attrezzo di questo esercizio manca.",
    "unavailableBadge": "Non c'è qui",
    "unavailableRestore": "Di nuovo disponibile qui",
    "unavailableErrorTitle": "Salvataggio non riuscito",
    "unavailableErrorBody": "L'attrezzo risulta ancora disponibile qui.",
    "unavailableConfirmHint": "Spuntane almeno uno per salvare.",
    "pinDefaultMachine": "Usa sempre la macchina predefinita qui",
    "pinMachine": "Usa sempre {{machine}} qui",
    "pinHint": "Smette di chiedere quale macchina, in questa palestra, per questo esercizio.",
    "pinErrorTitle": "Salvataggio non riuscito",
    "pinErrorBody": "La macchina predefinita qui non è cambiata.",
    "unpinDefaultMachine": "Smetti di usare sempre la macchina predefinita qui",
    "unpinMachine": "Smetti di usare sempre {{machine}} qui",
    "pinnedFootnoteDefault": "Qui si usa sempre la macchina predefinita.",
    "pinnedFootnoteMachine": "Qui si usa sempre {{machine}}.",
    "unpinHint": "Torna a chiedere quale macchina, in questa palestra, per questo esercizio."
  },
  "mobile": {
    "bodymap": {
      "muscle": {
        "chest": "Petto",
        "biceps": "Bicipiti",
        "triceps": "Tricipiti",
        "forearm": "Avambracci",
        "front-deltoids": "Spalle",
        "back-deltoids": "Deltoidi posteriori",
        "trapezius": "Trapezi",
        "upper-back": "Schiena",
        "lower-back": "Lombari",
        "abs": "Core",
        "obliques": "Core",
        "quadriceps": "Quadricipiti",
        "hamstring": "Femorali",
        "gluteal": "Glutei",
        "adductors": "Adduttori",
        "abductors": "Abduttori",
        "calves": "Polpacci",
        "tibialis": "Tibiale",
        "neck": "Collo",
        "head": "Testa"
      }
    },
    "tabs": {
      "workouts": "Allenamenti",
      "plan": "Home",
      "progress": "Progressi",
      "catalog": "Catalogo",
      "profile": "Profilo",
      "settings": "Impostazioni",
      "inbox": "Inbox",
      "athletes": "Atleti",
      "me": "Io"
    },
    "me": {
      "sectionTraining": "Allenamento",
      "navTargets": "Obiettivi",
      "navTargetsSub": "I tuoi target settimanali"
    },
    "settings": {
      "title": "Impostazioni",
      "exercisesSection": "Esercizi",
      "navExercisesSub": "MAX, catalogo, scala sforzo",
      "navCatalog": "Catalogo esercizi",
      "selectPrompt": "Seleziona un'impostazione per aprirla.",
      "navCatalogSub": "Sfoglia la libreria esercizi",
      "navEffort": "Impostazioni sforzo",
      "navEffortSub": "Scala RIR / RPE + legenda",
      "navLicenses": "Licenze open source",
      "navLicensesSub": "Le librerie che fanno funzionare l'app",
      "sectionAccount": "Account",
      "sectionTraining": "Allenamento",
      "sectionBody": "Corpo",
      "sectionPrefs": "Preferenze",
      "sectionCoach": "Coach",
      "sectionAbout": "Info",
      "sectionHealthConnect": "Health Connect",
      "navHealthConnect": "Health Connect",
      "navHealthConnectSub": "Sincronizza allenamenti e dati di salute dal dispositivo"
    },
    "energySource": {
      "zepp": "Zepp",
      "googleFit": "Google Fit",
      "healthConnect": "Health Connect",
      "jlEstimate": "JackedLogs",
      "pillLabel": "Origine calorie",
      "projectionNote": "Include la serie che stai per fare: una proiezione dell'intera seduta, non il lavoro che hai già registrato.",
      "selected": "selezionata"
    },
    "hc": {
      "preferences": "Preferenze",
      "caloriesWins": "Health Connect vince sulle calorie",
      "caloriesWinsHelp": "Quando esistono entrambe, mostra le calorie misurate da Health Connect invece della stima di JackedLogs. Off = preferisci la stima. Senza un valore da Health Connect, si usa sempre la stima.",
      "title": "Health Connect",
      "intro": "Importa l'attività di orologio e telefono in JackedLogs. Camminate, escursioni e uscite in bici diventano allenamenti; frequenza cardiaca e calorie arricchiscono le sessioni che registri. Spento finché non lo colleghi.",
      "checking": "Controllo…",
      "unavailable": "Health Connect non è disponibile su questo dispositivo.",
      "updateRequired": "Aggiorna l'app Health Connect per continuare.",
      "notConnected": "Non collegato.",
      "connect": "Collega Health Connect",
      "connectHelp": "Scegli tu quali dati JackedLogs può leggere. Puoi cambiarlo in qualsiasi momento in Health Connect.",
      "connected": "Collegato",
      "reads": "Legge allenamenti, frequenza cardiaca e calorie.",
      "syncNow": "Sincronizza ora",
      "neverSynced": "Mai sincronizzato.",
      "lastSyncedAt": "Ultima sincronizzazione: {{when}}",
      "syncDelayNote": "Una nuova attività può metterci qualche minuto ad arrivare su Health Connect dal tuo dispositivo: una camminata o una pedalata recente potrebbe comparire solo a una sincronizzazione successiva. È un ritardo normale.",
      "syncFullHistory": "Sincronizza tutto lo storico",
      "syncingFullHistory": "Sincronizzazione dello storico in corso",
      "syncFullHistoryHelp": "Ricontrolla tutto lo storico e colma eventuali buchi in Health Connect. Usalo se lì manca una correzione fatta in passato. Si può ripetere senza rischi.",
      "resultSummary": "{{imported}} importati · {{enriched}} arricchiti · {{skipped}} saltati",
      "error": "Qualcosa è andato storto. Riprova.",
      "manageInHc": "Gestisci in Health Connect",
      "disconnect": "Disconnetti",
      "disconnectTitle": "Disconnettere Health Connect?",
      "disconnectBody": "JackedLogs smetterà di leggere i tuoi dati di Health Connect. Gli allenamenti già importati restano nella cronologia.",
      "logoA11y": "Health Connect",
      "privacyTitle": "I tuoi dati",
      "privacyBody": "JackedLogs legge solo ciò che autorizzi in Health Connect, e solo su questo telefono dopo che ti colleghi. Sono salvati nel tuo account JackedLogs privato, mai condivisi né venduti. Disconnetti quando vuoi per fermare tutto.",
      "bodyResult": "{{imported}} corporee importate · {{skipped}} saltate",
      "bodyNotGranted": "Dati corporei non ancora concessi. Tocca Concedi dati corporei.",
      "readsFull": "Legge allenamenti, frequenza cardiaca e calorie, peso e composizione corporea, glicemia e nutrizione. Scrive la glicemia su Health Connect.",
      "backfillTitle": "Importare lo storico da maggio?",
      "backfillBody": "Scansiona lo storico di Health Connect fino a maggio e importa ciò che manca. Si può rilanciare senza problemi: gli elementi già importati vengono saltati.",
      "backfillNow": "Importa storico",
      "grantExtra": "Concedi dati salute",
      "extraGrantBody": "Importa anche peso, composizione corporea, glicemia e nutrizione.",
      "metabolicResult": "{{glucose}} glicemie · {{nutrition}} nutrizione importate",
      "metabolicNotGranted": "Glicemia e nutrizione non ancora concesse.",
      "writeGlucoseGrantBody": "Consenti a JackedLogs di scrivere la glicemia su Health Connect.",
      "grantWrite": "Consenti scrittura",
      "syncGlucoseToHc": "Scrivi glicemia su Health Connect"
    },
    "metabolic": {
      "title": "Metabolico",
      "loading": "Caricamento…",
      "empty": "Collega Health Connect e sincronizza per vedere qui glicemia e nutrizione.",
      "glucoseEmpty": "Nessuna lettura di glicemia",
      "glucoseLatest": "Ultima glicemia",
      "mgdl": "mg/dL",
      "targetBand": "Range target tipico {{lo}}–{{hi}} {{unit}}.",
      "carbsToday": "Carboidrati oggi",
      "grams": "g",
      "glucoseTitle": "Glicemia",
      "glucoseCurrent": "Ultima: {{value}} {{unit}}",
      "glucoseNone": "Registra una lettura per seguire la glicemia."
    },
    "exercisesScreen": {
      "back": "Indietro"
    },
    "body": {
      "back": "Indietro",
      "title": "Corpo",
      "navTitle": "Corpo",
      "navSub": "Sesso, età, figura, mappa del dolore",
      "trendsWebHint": "I grafici di composizione corporea sono nell'app mobile.",
      "sexLabel": "Sesso",
      "sexHelp": "Usato solo per la stima della massa grassa. La figura della mappa muscolare è una scelta separata qui sotto.",
      "sex_male": "Uomo",
      "sex_female": "Donna",
      "measurementsTitle": "Misure",
      "measurementsSub": "Peso, circonferenze, stima massa grassa",
      "measureTitle": "NUOVA MISURA",
      "weight": "Peso",
      "field_heightCm": "Altezza",
      "field_neckCm": "Collo",
      "field_chestCm": "Petto",
      "field_waistCm": "Vita",
      "field_hipsCm": "Fianchi",
      "field_bicepsLCm": "Bicipite (Sx)",
      "field_bicepsRCm": "Bicipite (Dx)",
      "field_forearmsLCm": "Avambraccio (Sx)",
      "field_forearmsRCm": "Avambraccio (Dx)",
      "field_thighsLCm": "Coscia (Sx)",
      "field_thighsRCm": "Coscia (Dx)",
      "field_calvesLCm": "Polpaccio (Sx)",
      "field_calvesRCm": "Polpaccio (Dx)",
      "measureSave": "Salva i valori inseriti",
      "measureHelpC": "Compila solo ciò che hai misurato. I campi vuoti non vengono salvati.",
      "useLastA11y": "Usa l'ultimo valore {{value}}",
      "saveFailedTitle": "Salvataggio non riuscito",
      "saveFailedBody": "La misura non è stata salvata. I valori restano — tocca Salva per riprovare.",
      "editTitle": "MODIFICA — {{date}}",
      "saveChanges": "Salva modifiche",
      "editCancelA11y": "Annulla modifica",
      "editRowA11y": "Modifica misura {{date}}",
      "editHelp": "Cambia un valore, oppure cancellalo per rimuoverlo dallo storico.",
      "trendsLabel": "TREND",
      "trendsHint": "scegli le misure",
      "trendsExpandA11y": "Mostra tutte le misure",
      "trendsCollapseA11y": "Comprimi le misure",
      "trendsEmpty": "Registra almeno 2 misure per vedere un trend.",
      "metricComposition": "Composizione",
      "metricBodyFat": "Grasso",
      "metricLeanMass": "Massa magra",
      "loadError": "Impossibile caricare le misure — controlla la connessione.",
      "queuedNote": "In attesa di sincronizzazione: {{count}}",
      "navyTitle": "COMPOSIZIONE CORPOREA (NAVY)",
      "navyNeedsEntry": "Salva una misura qui sotto per stimare la massa grassa.",
      "navyNeedsSex": "Imposta il sesso qui sopra per stimare la massa grassa.",
      "navyNeedsInputs": "Aggiungi altezza, collo e vita (e fianchi, per la formula femminile) per stimare la massa grassa.",
      "navyBodyFat": "Massa grassa ≈ {{pct}}%",
      "navyLeanMass": "Massa magra ≈ {{mass}}",
      "navyDisclaimer": "Stima US Navy (~±3,5%). Guarda l'andamento, non il singolo numero.",
      "historyEmpty": "Ancora nessuna misura. Salvane una qui sopra per iniziare a monitorare.",
      "historyTitle": "STORICO",
      "trendWeight": "ANDAMENTO PESO",
      "trendBodyFat": "ANDAMENTO MASSA GRASSA",
      "deleteTitle": "Eliminare la misura?",
      "deleteEmptyTitle": "Rimuovere questa misura?",
      "deleteEmptyBody": "Tutti i suoi valori sono stati cancellati, quindi la voce verrà eliminata.",
      "deleteCancel": "Annulla",
      "deleteConfirm": "Elimina",
      "ageLabel": "Età",
      "ageHelp": "Opzionale. Tocca di nuovo per azzerare.",
      "dualCurveLegend": "Linea piena: stima · Tratteggio: Health Connect",
      "bodyFatProvenance": "Il grasso si calcola misurando vita e collo.",
      "bodyFatProvenanceWithHips": "Il grasso si calcola misurando vita, collo e fianchi."
    },
    "effortSettings": {
      "back": "Indietro",
      "title": "Sforzo",
      "scaleLabel": "Scala dello sforzo",
      "scaleHelp": "Quale scala usa il Logger. RIR = ripetizioni che ti restano in tasca; RPE = sforzo percepito. RPE = 10 − RIR, quindi sono lo stesso sforzo su due scale."
    },
    "plan": {
      "currentBlockError": "Impossibile impostare il blocco attivo. Riprova.",
      "currentBlockOn": "Blocco attivo — tocca per rimuovere",
      "currentBlockOff": "Imposta come blocco attivo",
      "currentBlockHint": "Fissa i target settimanali di questo programma sul meter della Home",
      "title": "Pianifica",
      "start": "Inizia",
      "starting": "Apertura…",
      "programWeekSession": "Settimana {{week}}/{{cycle}} · {{session}}",
      "programLastCompleted": "Ultima: S{{week}} · {{session}}",
      "programNextHeader": "Prossima",
      "programStartCta": "▶ Inizia {{session}}",
      "programChangeLink": "Cambia settimana o sessione ›",
      "carouselPosition": "Programma {{n}} di {{total}}",
      "carouselPrev": "Programma precedente",
      "carouselNext": "Programma successivo",
      "programWeekLabel": "Settimana",
      "singleCycle": "Ciclo unico, uguale ogni settimana",
      "programSessionLabel": "Sessione",
      "programWeekShort": "S{{n}}",
      "programDayShort": "G{{n}}",
      "sessionN": "Sessione {{n}}",
      "sessionNShort": "S{{n}}",
      "programConfirm": "Inizia S{{week}} · {{session}}",
      "cancel": "Annulla",
      "newWorkout": "Nuovo allenamento",
      "programsHint": "Cicli multi-settimana che avanzano in automatico quando registri le sessioni.",
      "planDeleteTitle": "Eliminare il piano?",
      "programDeleteTitle": "Eliminare il programma?",
      "programStatusError": "Impossibile aggiornare il programma. Riprova.",
      "view": "Vedi",
      "hide": "Nascondi",
      "programUnfollowHint": "Smetti di seguire questo programma (resta in I miei programmi)",
      "programNextInline": "Prossimo: W{{week}} · {{session}}",
      "programStartA11y": "Avvia {{session}}",
      "startPlanA11y": "Avvia {{name}}"
    },
    "preview": {
      "muscles": "Muscoli",
      "noSets": "Nessuna serie prevista",
      "alternates": "Alternative: {{names}}",
      "gridTitle": "Intensità · giorno × settimana",
      "gridHint": "Tocca un giorno per vederne le alzate.",
      "matrixTitle": "Intensità · per serie",
      "matrixHint": "Tocca un esercizio per vederne le serie.",
      "restDay": "Riposo / leggero",
      "intensity": {
        "work": "lavoro",
        "moderate": "moderato",
        "heavy": "pesante",
        "max": "Max",
        "free": "libero"
      }
    },
    "catalog": {
      "title": "Catalogo",
      "search": "Cerca esercizi",
      "empty": "Nessun esercizio corrisponde.",
      "back": "Indietro",
      "notFound": "Esercizio non trovato.",
      "metaPrimaryMuscle": "Muscolo primario",
      "metaPattern": "Pattern",
      "metaEquipment": "Attrezzo",
      "metaP1RM": "Programmabile",
      "metaP1RMYes": "Sì",
      "metaP1RMNo": "No",
      "metaDefaultBar": "Bilanciere predefinito",
      "metaBarLoading": "Caricamento bilanciere",
      "metaBarLoadingLandmine": "Landmine (singola estremità)",
      "aliasesLabel": "Conosciuto anche come",
      "tagsLabel": "Tag",
      "historyLabel": "Sessioni recenti",
      "historyEmpty": "Nessuna sessione passata per questo esercizio.",
      "historyError": "Impossibile caricare la cronologia.",
      "historyBodyweight": "{{reps}} reps a corpo libero",
      "recordsLabel": "Record",
      "recordsEmpty": "Ancora nessun record.",
      "selectPrompt": "Seleziona un esercizio per vederne i dettagli.",
      "recordsError": "Impossibile caricare i record.",
      "refreshing": "Aggiornamento…"
    },
    "maxes": {
      "title": "MAX",
      "back": "Indietro",
      "search": "Cerca esercizi",
      "empty": "Nessun esercizio corrisponde.",
      "editCancel": "Annulla",
      "editSave": "Salva",
      "errInvalid": "Inserisci un peso valido.",
      "clearAction": "Rimuovi MAX",
      "clearTitle": "Rimuovere questo MAX?",
      "clearBody": "Il valore corrente e lo storico restano sul server, ma il MAX risulterà non impostato.",
      "clearCancel": "Annulla",
      "clearConfirm": "Rimuovi",
      "selectPrompt": "Seleziona un esercizio per impostarne il MAX.",
      "unitChipLabel": "Unità di peso: {{unit}}",
      "unitKg": "chilogrammi",
      "unitLb": "libbre",
      "unitChipHint": "Cambia unità e converte il valore"
    },
    "login": {
      "title": "JackedLogs",
      "subtitle": "Accedi al tuo account",
      "submit": "Accedi"
    },
    "workouts": {
      "title": "Allenamenti",
      "empty": "Nessun allenamento registrato.",
      "fallbackName": "Allenamento",
      "endOfList_one": "{{count}} sessione — fine.",
      "endOfList_other": "{{count}} sessioni — fine.",
      "newButton": "Nuovo",
      "queuedBanner_one": "{{count}} workout in coda. Tocca per riprovare.",
      "queuedBanner_other": "{{count}} workout in coda. Tocca per riprovare.",
      "maxQueuedBanner_one": "{{count}} MAX in coda. Si sincronizza da solo quando torna la rete.",
      "maxQueuedBanner_other": "{{count}} MAX in coda. Si sincronizzano da soli quando torna la rete.",
      "maxQueuedHint": "Tocca per sincronizzare adesso.",
      "maxConfirmFailedTitle": "MAX non salvato",
      "maxConfirmFailedBody": "Il server non ha accettato questo valore, quindi non è stato scritto niente. Il tuo MAX resta com'era. Puoi impostarlo a mano da Me, Massimali.",
      "queuedRetry": "Riprova",
      "queuedDetail": "Dettagli",
      "queuedHint": "Tocca per riprovare ora, tieni premuto per scartare.",
      "queuedHintDetail": "Tocca per vedere cosa è in coda, tieni premuto per scartare.",
      "queueDismissTitle": "Scartare i workout in coda?",
      "queueDismissBody_one": "{{count}} workout verrà rimosso e non salvato.",
      "queueDismissBody_other": "{{count}} workout verranno rimossi e non salvati.",
      "queueDismissCancel": "Annulla",
      "queueDismissConfirm": "Scarta",
      "editUnsupportedTitle": "Modifica non ancora supportata su mobile",
      "editUnsupportedBody": "Questo workout contiene tipi di esercizi (P1RM, loaded carry) che il logger mobile non sa ancora modificare. Aprilo sull'app web.",
      "editUnsupportedAck": "OK",
      "maxBumpHeader_one": "{{count}} nuovo MAX",
      "maxBumpHeader_other": "{{count}} nuovi MAX",
      "maxBumpRow": "{{exercise}}: {{valueKg}} kg",
      "maxBumpConfirm": "Conferma",
      "maxBumpDismiss": "Salta",
      "repeat": "Ripeti l'allenamento",
      "resumePillAction": "Riprendi",
      "resumePillFallback": "Allenamento in corso",
      "cancel": "Annulla",
      "loadOlder": "Carica i mesi precedenti",
      "selectPrompt": "Seleziona un allenamento per vederne il riepilogo.",
      "loadError": "Impossibile caricare questa sessione.",
      "maxDropRow": "{{exercise}}: il MAX potrebbe essere sceso a {{valueKg}} kg (era {{currentKg}}, {{weeks}} sett. fa)",
      "maxDropConfirm": "Abbassa a {{valueKg}}",
      "maxDropKeep": "Lascia {{valueKg}}",
      "maxDropBadDay": "Brutta giornata",
      "importedBadge": "Importato"
    },
    "outboxDetail": {
      "title": "Workout in coda",
      "close": "Chiudi",
      "empty": "Niente in coda.",
      "statusQueued": "In coda",
      "statusSending": "Invio in corso",
      "statusFailed4xx": "Server ha rifiutato",
      "statusPermanentFail": "Ho rinunciato",
      "attempts_one": "{{count}} tentativo",
      "attempts_other": "{{count}} tentativi",
      "dismissOne": "Scarta",
      "dismissOneTitle": "Scartare questo workout?",
      "dismissOneBody": "Il workout del {{date}} sarà rimosso senza essere salvato.",
      "dismissCancel": "Annulla",
      "dismissConfirm": "Scarta",
      "retryAll": "Riprova tutto",
      "dismissAll": "Scarta tutto",
      "queueWorkout": "Allenamento",
      "queueWorkoutNote": "Nota allenamento",
      "queueMeasurement": "Misurazione",
      "queueMax": "Massimale",
      "queueProfile": "Profilo",
      "queueHealth": "Dati salute",
      "queueMetabolic": "Dati metabolici",
      "queueRequest": "Modifica",
      "stuckTitle": "Salvataggi non passati"
    },
    "stuckWrites": {
      "banner_one": "{{count}} salvataggio non è passato",
      "banner_other": "{{count}} salvataggi non sono passati",
      "retry": "Riprova ora",
      "retrying": "Riprovo…",
      "details": "Dettagli"
    },
    "progress": {
      "title": "Progressi",
      "windowAll": "Sessioni recenti",
      "window30d": "Ultimi 30 giorni",
      "window7d": "Ultimi 7 giorni",
      "lastSession": "Ultima sessione",
      "frequencyTitle": "Frequenza settimanale",
      "frequencyHelp": "Sessioni a settimana, ultime {{weeks}} settimane (settimana corrente a destra).",
      "recordsTitle": "Record",
      "recordsHelp": "Migliori record per ripetizione per esercizio. Più recenti in alto.",
      "recordsEmpty": "Nessun record. Logga qualche serie con peso per popolare la lista.",
      "recordsAllTime": "Sempre",
      "recordsThisYear": "{{year}}",
      "recordsSearch": "Filtra per esercizio",
      "recordsNoMatch": "Nessun esercizio corrisponde al filtro.",
      "tagVolumeTitle": "Volume per tag",
      "tagVolumeHelp": "Volume di allenamento per muscolo/tag nella finestra recente.",
      "chartE1rm": "1RM stimato",
      "chartVolume": "Volume",
      "chartScope": "Basato sulle ultime {{n}} sessioni.",
      "chartLoadFailed": "Impossibile caricare il grafico.",
      "chartEmpty": "Nessuna serie con peso nella finestra recente.",
      "viewByExercise": "Per esercizio",
      "viewByTag": "Per tag",
      "noTags": "Nessun esercizio con tag nella finestra recente.",
      "totalVolume": "Totale: {{weight}}",
      "chartMax": "MAX (kg)",
      "chartEstimatedBadge": "con overlay e1RM",
      "prFound": "PR trovato: {{weight}}",
      "prUpdate": "Aggiorna MAX a {{weight}}",
      "prUpdating": "Aggiorno…",
      "painSeverity": {
        "red": "rosso",
        "yellow": "giallo",
        "green": "verde"
      },
      "balance": {
        "title": "Bilanciamento dei movimenti",
        "help": "Serie e volume per pattern di movimento nella finestra selezionata di {{days}} giorni, ordinati per serie. Il piccolo numero \"X/7g\" è il conteggio degli ultimi 7 giorni, utile per individuare una singola spinta recente (o un calo voluto) che la finestra più lunga nasconde."
      },
      "empty": "Nessuna attività recente da confrontare",
      "pain": {
        "title": "Dolore × volume",
        "help": "Per ogni muscolo attualmente segnalato nella painMap, mostra il carico di allenamento recente. Pallino rosso = dolore segnalato rosso (evita carichi pesanti), giallo = cautela, verde = monitora. I due numeri di volume sono il carico ultimi 7 giorni vs la finestra selezionata di {{days}} giorni su quel muscolo — un carico pesante prolungato su un muscolo rosso è il segnale a più alto rischio della dashboard.",
        "noPain": "Nessun muscolo segnalato in painMap",
        "sevRed": "Evita",
        "sevYellow": "Cautela",
        "sevGreen": "Monitora"
      },
      "trends": {
        "a11yUp": "in progressione",
        "a11yFlat": "plateau",
        "a11yDown": "in regressione",
        "title": "Trend E1RM",
        "help": "Per ogni pattern di movimento (squat, hinge, push, pull, …) mostra l'esercizio in cui il tuo e1RM massimo è più alto. Grafico = punti e1RM nella finestra selezionata di {{days}} giorni (tocca un punto per il valore). Freccia = trend su quella finestra: ↗ in progressione, → plateau, ↘ in regressione. Il badge \"Pochi dati\" appare quando ci sono meno di 3 punti per tracciare una linea.",
        "fewData": "Pochi dati in {{days}} g",
        "notMeasurable": "Non ancora misurabile: nessuna serie di {{name}} è andata vicino al limite. Una serie portata quasi a cedimento (un AMRAP) mostrerebbe qui la tua forza.",
        "machineNotMeasurable": "{{value}}, non ancora misurabile",
        "machineMore": "{{machine}} · +{{count}}",
        "machineA11y_one": "{{exercise}}, {{machine}}. Mostra l'altra macchina.",
        "machineA11y_other": "{{exercise}}, {{machine}}. Mostra le altre {{count}} macchine.",
        "machineSessions_one": "{{count}} seduta",
        "machineSessions_other": "{{count}} sedute"
      },
      "repsAtLoad": {
        "a11yUp": "in salita",
        "a11yFlat": "stabile",
        "a11yDown": "in calo",
        "title": "Ripetizioni a carico fisso",
        "help": "Per gli esercizi in cui ripeti lo stesso carico, mostra come vanno le ripetizioni a quel peso fisso nella finestra di {{days}} giorni — il guadagno di forza che il grafico e1RM non vede sugli alti-rep e sulle macchine. Grafico = ripetizioni al carico nel tempo (tocca un punto). Freccia = trend: ↗ in salita, → stabile, ↘ in calo. Contano solo le serie con lo sforzo registrato, così più ripetizioni non possono voler dire solo una giornata più facile.",
        "repsValue": "{{reps}} × {{load}}",
        "fewData": "Pochi dati in {{days}} g",
        "notMeasurable": "Non ancora misurabile: le tue serie di {{name}} a {{load}} non hanno lo sforzo registrato, quindi più ripetizioni potrebbero voler dire solo una giornata più facile. Una serie portata quasi a cedimento — o lo sforzo registrato — mostrerebbe qui la tua forza."
      },
      "period": {
        "all": "tutto"
      },
      "loadFailed": "Impossibile caricare",
      "density": {
        "title": "Densità",
        "help": "Volume diviso per la durata della sessione, kg/min. Si legge come \"quanto era densa quella sessione\" — in salita significa che fai lo stesso carico in meno tempo (migliore condizionamento) o più carico nello stesso tempo (migliore forza). Un calo improvviso senza cambiare il programma spesso indica fatica: i recuperi si sono allungati anche se non era previsto.",
        "empty": "Servono 3+ sessioni cronometrate per tracciare la densità"
      },
      "frequency": {
        "title": "Esercizi più trascurati",
        "help": "Top 8 esercizi ordinati per giorni dall'ultima registrazione, dai più trascurati. Il suffisso X/{{days}}g è il conteggio delle serie nella finestra selezionata. Numeri in rosso = 14+ giorni intoccato: o l'hai tagliato di proposito o il programma è andato alla deriva. Utile per individuare il lavoro accessorio sparito in silenzio.",
        "today": "oggi",
        "daysAgo": "{{n}} g fa"
      },
      "fatigueDrift": {
        "title": "Affaticamento (RIR)",
        "help": "Media settimanale rolling di RPE e ripetizioni in riserva sui set in cui sono entrambi loggati. RPE in salita e RIR in discesa a carichi simili = fatica accumulata che si vede prima che il bilanciere rallenti. Una settimana di scarico di solito risolve.",
        "noData": "Logga RPE e RIR su qualche set per vedere il drift di affaticamento",
        "rising": "Affaticamento in salita",
        "stable": "Stabile",
        "legend": "RPE (sinistra) · RIR (destra) — tocca una settimana per i valori"
      },
      "intensityHeatmap": {
        "title": "Heatmap di intensità",
        "help": "Griglia per-esercizio dei set completati ordinati per fascia di ripetizioni e intensità (% del 1RM). Range di forza (85%+) in basso a destra, ipertrofia in mezzo, resistenza in alto a sinistra. Scegli un esercizio per vedere dove si concentrano i suoi set.",
        "exerciseLabel": "Esercizio",
        "choosePrompt": "Scegli un esercizio",
        "noEligible": "Registra un 1RM su almeno un esercizio per calcolare l'intensità.",
        "noMax": "Nessun 1RM registrato per questo esercizio.",
        "totalSets": "{{n}} set · 1RM {{max}}",
        "clear": "Nessuno"
      },
      "a11y": {
        "severityAlarm": "Allarme",
        "severityWarn": "Avviso",
        "severityInfo": "Info",
        "stale": "Inattivo"
      }
    },
    "profile": {
      "title": "Profilo",
      "navMaxes": "MAX",
      "navMaxesSub": "Imposta, modifica e rivedi i tuoi MAX per esercizio.",
      "navCatalogSub": "Sfoglia esercizi, record e cronologia.",
      "navRestTimer": "Timer",
      "navRestTimerSub": "Default recupero + tenuta, suono, per esercizio",
      "labelEmail": "EMAIL",
      "labelApp": "VERSIONE APP",
      "labelBackend": "VERSIONE BACKEND",
      "labelPrivacy": "PRIVACY",
      "privacyHelp": "Esporta tutto in JSON o cancella l'account in modo definitivo.",
      "exportButton": "Esporta i miei dati",
      "deleteButton": "Elimina il mio account",
      "deleteAlertTitle": "Elimina account",
      "deleteAlertBody": "Verranno eliminati definitivamente il tuo account, le sessioni, i piani, i programmi e i MAX. Le cancellazioni non si recuperano.",
      "deleteAlertCancel": "Annulla",
      "deleteAlertConfirm": "Elimina",
      "signOut": "Esci",
      "exportShareTitle": "Export JackedLogs {{date}}",
      "labelLanguage": "Lingua",
      "languageHelp": "Scegli la lingua usata nell'app. Salvata su questo dispositivo.",
      "languageCancel": "Chiudi"
    },
    "summary": {
      "prBadge": "record personale"
    },
    "logger": {
      "title": "Nuovo workout",
      "cancel": "Annulla",
      "swapKindTitle": "Cambiare tipo di esercizio?",
      "swapKindBody": "Questo esercizio si registra in modo diverso, quindi i set già inseriti qui verranno cancellati.",
      "swapKindConfirm": "Cambia e cancella",
      "failConfirmTitle": "Reps valide",
      "failConfirmBody_one": "Salvo {{count}} rep pulita. Quella fallita non conta.",
      "failConfirmBody_other": "Salvo {{count}} rep pulite. Quella fallita non conta.",
      "failConfirmHint": "Correggi se ne hai fatte di più o di meno.",
      "failConfirmStepDown": "Una rep pulita in meno",
      "failConfirmStepUp": "Una rep pulita in più",
      "failConfirmSave": "Salva",
      "amrapConfirmTitle": "Fino a cedimento?",
      "amrapConfirmBody": "Rispondi sì solo se la ripetizione dopo non sarebbe salita.",
      "amrapNeedsReps": "Scrivi le ripetizioni che hai fatto per registrare la serie.",
      "amrapBadgeWithFloor": "AMRAP ≥ {{reps}}",
      "amrapPrescribedFloorA11y": "AMRAP: almeno {{reps}} ripetizioni, poi il più possibile",
      "amrapConfirmAtFloor": "Hai segnato {{reps}}, e il programma ne chiedeva almeno {{floor}}.",
      "amrapFloorPlaceholder": "≥ {{reps}}",
      "amrapConfirmYes": "Sì, a cedimento",
      "amrapConfirmNo": "No, ne avevo ancora",
      "failBadge": "Fallita",
      "failBadgeA11y": "serie fallita",
      "save": "Salva",
      "remove": "Rimuovi",
      "replace": "Sostituisci",
      "addExercise": "Aggiungi esercizio",
      "addSet": "Aggiungi serie",
      "addRound": "Aggiungi giro",
      "pickerTitle": "Scegli esercizio",
      "pickerSearch": "Cerca esercizi",
      "pickerEmpty": "Nessun esercizio corrisponde.",
      "pickerClearFilters": "Pulisci filtri",
      "pickerFilters": "Filtri",
      "pickerFiltersN": "Filtri ({{n}})",
      "empty": "Nessun esercizio. Aggiungine uno per iniziare.",
      "setReps": "RIP",
      "amrapPrescribedA11y": "AMRAP: almeno le ripetizioni previste, poi quante ne riesci",
      "setWeight": "KG",
      "setWeightLb": "LB",
      "setWeightBothSidesA11y": "Peso di un lato, contati entrambi i lati ({{unit}})",
      "setTypeWorking": "Normale",
      "setTypeDropset": "Dropset",
      "setTypeMyorep": "Myo-rep",
      "setCommentLabel": "Commento del set",
      "unitLabel": "Unità",
      "discardTitle": "Scartare il workout?",
      "discardBody": "Perderai le serie inserite fin qui.",
      "discardCancel": "Continua",
      "discardConfirm": "Scarta",
      "errNoEntries": "Aggiungi almeno un esercizio.",
      "errNoSets": "Ogni esercizio richiede almeno una serie con ripetizioni e peso.",
      "errInvalid": "Il workout non si può salvare così.",
      "errSaveFailed": "Salvataggio fallito. Premi riprova sul banner della coda quando sei online.",
      "setNumberHeader": "SET",
      "removeSetA11y": "Rimuovi questa serie",
      "serverErrorTitle": "IL SERVER HA RIFIUTATO IL SALVATAGGIO",
      "serverErrorHint": "Correggi il workout e riprova. Se il messaggio non è chiaro, condividilo con il tuo coach.",
      "setExtra": "EXTRA",
      "bwPromptTitle": "Registra il tuo peso corporeo",
      "bwPromptBody": "Gli esercizi a corpo libero hanno bisogno del tuo peso per calcolare carico e volume. Impostalo in Impostazioni → Corpo.",
      "bwPromptCta": "Imposta",
      "setWeightTip": "Peso sollevato per serie. Cambia kg/lb col chip unità su ogni riga.",
      "setExtraTip": "Assistenza o carico aggiunto al corpo libero. Scrivi un meno (−) per l'assistenza con elastico/macchina (il campo diventa ambra); cintura/disco aggiunto è positivo.",
      "setWeightMixedTip": "Gruppo misto: carico bilanciere/stack nelle righe con peso, ± extra nelle righe a corpo libero (meno = assistenza).",
      "editTitle": "Modifica workout",
      "planTitle": "Pianifica",
      "programTitle": "Programma",
      "repeatTitle": "Ripeti workout",
      "minimize": "Riduci workout",
      "closeWorkout": "Chiudi workout",
      "saveWorkout": "Salva workout",
      "bilateral": "Bilaterale",
      "unilateral": "Unilaterale",
      "plates": "Dischi",
      "numInvalid": "Numero non valido",
      "numRange": "{{label}} {{min}}–{{max}}",
      "setRpeHint": "Sforzo 1–10",
      "setNoteLabel": "Nota",
      "setNotePlaceholder": "Cue, tecnica, sensazione…",
      "elapsedA11y": "Tempo trascorso",
      "totalsSets_one": "{{count}} serie",
      "totalsSets_other": "{{count}} serie",
      "totalsReps_one": "{{count}} rep",
      "totalsReps_other": "{{count}} reps",
      "totalsTitle": "Totali workout",
      "totalsVolume": "Volume",
      "totalsSetsShort": "Serie",
      "totalsRepsShort": "Reps",
      "totalsByMuscle": "Lavoro per muscolo",
      "restRest": "Recupero",
      "startRestManual": "Avvia recupero",
      "restSkip": "Salta",
      "restWord": "Riposo",
      "restAddStep": "+{{n}} secondi",
      "restSubtractStep": "−{{n}} secondi",
      "restRemainingA11y": "{{time}} di riposo",
      "restLockedA11y": "Modifiche bloccate durante il recupero. Tocca «salta» per modificare.",
      "restEditA11y": "Imposta il recupero predefinito per questo esercizio",
      "restEditTitle": "Recupero predefinito",
      "restEditBody": "Salva questo recupero come predefinito per {{name}}",
      "restEditSave": "Salva",
      "restEditSaving": "Salvataggio…",
      "restEditError": "Impossibile salvare il recupero predefinito. Riprova.",
      "restEditCancel": "Annulla",
      "restEditSaveAsGlobal": "Usa come default globale",
      "restStepMinus": "Diminuisci di {{step}} secondi",
      "restStepPlus": "Aumenta di {{step}} secondi",
      "restPause": "Pausa",
      "restResume": "Riprendi",
      "restExpiredTitle": "Riposo finito",
      "holdExpiredTitle": "Tempo finito",
      "restExpiredBody": "È ora di riprendere.",
      "holdExpiredBody": "Tocca la banda dello sforzo per registrare la serie.",
      "boutExpiredTitle": "Bout finito",
      "boutExpiredBody": "Serie registrata da sola.",
      "boutAutoLoggedA11y": "Bout finito, {{time}} registrati.",
      "workoutFgsTitle": "Allenamento in corso",
      "workoutFgsBodyNamed": "{{name}} · tocca per riprendere",
      "workoutFgsBody": "Tocca per riprendere la sessione",
      "descriptionToggle": "Mostra / nascondi descrizione",
      "notesToggle": "Note del coach per questo allenamento",
      "notesProgramLabel": "Programma",
      "notesWorkoutLabel": "Questo allenamento",
      "note": "Nota",
      "rpeChip": "RPE",
      "historyChip": "Storico",
      "more": "Altre azioni",
      "addGroup": "Raggruppa con un altro esercizio",
      "cardioDuration": "Durata",
      "cardioDurationPlaceholder": "Secondi",
      "cardioDistance": "Distanza",
      "cardioWeight": "Peso",
      "cardioHr": "FC media",
      "cardioCalories": "Calorie",
      "cardioOptionalsShow": "Mostra altri campi",
      "cardioOptionalsHide": "Nascondi altri campi",
      "dateEditor": "Data e durata",
      "dateLabel": "Data",
      "startTimeLabel": "Inizio",
      "endTimeLabel": "Fine",
      "durationLabel": "Durata",
      "historyToggle": "Storico",
      "historyCount_one": "{{count}} sessione",
      "historyCount_other": "{{count}} sessioni",
      "historyBest": "Migliore",
      "historyCopy": "Copia",
      "historyBodyweight": "{{reps}} reps PC",
      "historyEstimateHeader": "Stima da un esercizio simile",
      "historyEstimatedFrom": "Da {{name}}",
      "historyNoEstimate": "Nessuno storico, e nessun esercizio simile da cui stimare.",
      "copyDialogTitle": "Copia sessione",
      "copyDialogBody": "Sovrascrivi le serie in attesa o aggiungile alle esistenti?",
      "copyOverwrite": "Sovrascrivi",
      "copyAppend": "Aggiungi",
      "resumeTitle": "Riprendere il workout?",
      "resumeBody": "Hai iniziato un workout il {{date}} che non è stato salvato. Vuoi riprenderlo o scartarlo?",
      "resumeContinue": "Riprendi",
      "resumeDiscard": "Scarta",
      "conflictTitle": "Allenamento in corso",
      "conflictBody": "Stai già registrando un allenamento. Continua oppure mostralo per salvarlo o scartarlo.",
      "nameLabel": "Nome workout",
      "namePlaceholder": "Nome: es. Push…",
      "editNameA11y": "Modifica nome allenamento",
      "setStateA11y": "serie {{index}} {{state}}",
      "rpePlaceholder": "RPE",
      "unitA11y": "unità {{unit}}",
      "stepperPositive": "aggiungi",
      "stepperNegative": "sottrai",
      "historyCount": "{{n}} sessioni",
      "rirPlaceholder": "RIR",
      "effortMeterEasy": "Facile",
      "effortMeterHard": "Difficile",
      "effortWord": "Sforzo",
      "holdSlotDone": "FATTO",
      "holdSlotHeld": "TENUTO",
      "holdSlotDoneA11y": "{{time}} fatti",
      "holdSlotFailedA11y": "{{time}}, non completato",
      "holdSlotHeldA11y": "{{time}} tenuti",
      "effortMeterFail": "Fail",
      "effortMeterTargetWord": "obiettivo",
      "effortQuestionRir": "Reps in riserva?",
      "effortQuestionRpe": "Quanto è stato duro?",
      "effortQuestionHint": "Apre la scala dello sforzo — com'è fatta e come cambiarla",
      "effortMeterHintLog": "Registra anche il set come completato",
      "effortMeterHintRunning": "Ferma il timer e registra la serie",
      "effortMeterHintEdit": "Aggiorna lo sforzo di questo set registrato",
      "effortMeterFailHintLog": "Registra il set come fallito",
      "effortMeterFailHintEdit": "Alterna il set tra completato e fallito",
      "effortMeterTapCta": "Tocca per registrare il set",
      "effortMeterStopCta": "Tocca per fermare e registrare",
      "effortNudgeOptOut": "Disattiva promemoria",
      "effortNudgeOptOutHint": "Prima chiede conferma. Puoi riattivarlo in Impostazioni.",
      "effortNudgeOptOutConfirmTitle": "Disattivare questo promemoria?",
      "effortNudgeOptOutConfirmBody": "Puoi riattivarlo in qualsiasi momento in Impostazioni.",
      "effortNudgeOptOutConfirmButton": "Disattiva",
      "effortMeterAmrapDone": "Fatto",
      "effortMeterAmrapHint": "Registra la serie a cedimento — nessuna ripetizione rimasta",
      "amrapChip": "Più ripetizioni possibili",
      "burnPlus": "Burn+",
      "burnPlusChip": "Tecnica di intensità Burn+ (dropset / myo-rep)",
      "loadAxisTitle": "Cosa determina il carico",
      "applyToAllSets": "Applica a tutte le set",
      "applyToAllConfirm": "Sovrascrivere tutte le serie con la prescrizione di questa serie?",
      "timedChip": "A tempo",
      "noteChip": "Nota",
      "noteClose": "Fatto",
      "effortLegendA11y": "Aiuto sulla scala dello sforzo",
      "rirLegendTitle": "RIR: ripetizioni di riserva",
      "rirLegendBody": "0 = nessuna ripetizione in tasca\n1 = 1 ripetizione in tasca\n2 = 2 ripetizioni\n3 = buon margine\n4+ = facile / riscaldamento",
      "rpeLegendTitle": "RPE: sforzo percepito",
      "rpeLegendBody": "10 = nessuna ripetizione in tasca\n9 = 1 ripetizione in tasca\n8 = 2 ripetizioni\n7 = buon margine\n6 o meno = facile / riscaldamento",
      "timerStartCountdown": "Avvia il conto alla rovescia",
      "timerStartCountup": "Avvia il cronometro",
      "timerSettings": "Timer predefiniti per questo esercizio",
      "holdHeaderHours": "h",
      "holdHeaderMinutes": "min",
      "holdHeaderSeconds": "s",
      "holdHours": "Ore",
      "holdMinutes": "Minuti",
      "holdSeconds": "Secondi",
      "holdSubTen": "-10s",
      "holdAddTen": "+10s",
      "holdCancel": "Annulla",
      "holdClockElapsedA11y": "{{time}} trascorsi",
      "holdClockOvertimeA11y": "{{time}} oltre il target",
      "holdClockPausedA11y": "{{label}}, in pausa",
      "holdClockRemainingA11y": "{{time}} rimanenti",
      "holdFlip": "Cambia direzione",
      "holdExtraWeight": "Extra",
      "lateralityTipUni": "UNI · registra un lato; il volume conta entrambi (×2).",
      "lateralityTipBi": "BI · carico bilaterale; il volume conta una volta (×1).",
      "tabExercises": "Esercizi",
      "tabSuperset": "Superset",
      "pickerAddN": "Aggiungi {{n}}",
      "pickerAlreadyInWorkout": "Già in questo allenamento",
      "pickerAlreadyInBlock": "Già in questo blocco",
      "pickerPin": "Aggiungi ai preferiti",
      "pickerUnpin": "Rimuovi dai preferiti",
      "noteReadA11y": "Nota esercizio — tocca per leggerla intera",
      "prescriptionReadA11y": "Indicazione serie — tocca per leggerla intera",
      "helpToggle": "Aiuto — tocca un chip per scoprire cosa fa",
      "tipAmrap": "Più ripetizioni possibili — porta la serie al cedimento tecnico.",
      "tipBurnPlus": "Tecniche di intensità — mostra Dropset o Myo-rep per spingere la serie oltre il cedimento.",
      "helpBanner": "Modalità aiuto — tocca un chip per scoprire cosa fa; tocca ⓘ per uscire.",
      "helpModeHint": "Modalità aiuto attiva — spiega invece di cambiare l’impostazione.",
      "targetsMore": "+{{count}} altri",
      "targetEyebrow": "Traguardo"
    },
    "coachBanner": {
      "a11y": "{{count}} inviti coach in attesa",
      "one": "1 invito coach in attesa",
      "many": "{{count}} inviti coach in attesa",
      "action": "Apri"
    },
    "coachEdges": {
      "empty": "Nessun edge coach. Un coach può invitarti dall'app web."
    },
    "toxicDraft": {
      "banner": "Ho recuperato un workout corrotto.",
      "viewJson": "Visualizza JSON",
      "sendSupport": "Invia al supporto",
      "dismiss": "Scarta",
      "close": "Chiudi",
      "jsonTitle": "Workout in quarantena",
      "supportPrefix": "Draft corrotto rilevato automaticamente dal contatore di boot. JSON in quarantena qui sotto.",
      "sentTitle": "Invio al supporto",
      "sentBody": "Dati di recupero inviati.",
      "sendError": "Invio fallito. Il workout è ancora in quarantena."
    },
    "recovery": {
      "banner": "Allenamento recuperato",
      "summary": "{{date}} · {{exercises}} esercizi · {{done}}/{{total}} serie fatte",
      "saveAsNew": "Salva come nuovo",
      "discard": "Scarta",
      "title": "Allenamento recuperato",
      "openBody": "Questo allenamento era stato interrotto ed è stato recuperato. Controlla le serie e tocca Salva per registrarlo come nuovo allenamento.",
      "open": "Apri",
      "cancel": "Annulla",
      "liveBusy": "Hai un allenamento in corso. Salvalo o scartalo prima di recuperare questo.",
      "discardTitle": "Scartare l'allenamento recuperato?",
      "discardBody": "L'allenamento recuperato verrà eliminato definitivamente.",
      "discardConfirm": "Scarta",
      "error": "Impossibile recuperare l'allenamento. Riprova.",
      "merge": "Unisci…",
      "mergeTitle": "Unisci allenamento",
      "mergePrompt": "Scegli un allenamento dello stesso giorno in cui unire:",
      "noSameDay": "Nessun allenamento dello stesso giorno in cui unire. Usa \"Salva come nuovo\".",
      "nothingToMerge": "Nessuna serie completata da unire. Usa \"Salva come nuovo\"."
    },
    "group": {
      "title": "Raggruppa questo esercizio",
      "close": "Chiudi",
      "standalone": "Singolo",
      "supersetSection": "SUPERSET",
      "circuitSection": "CIRCUITI",
      "supersetN": "Superset {{n}}",
      "circuitN": "Circuito {{n}}",
      "newSuperset": "+ Nuovo superset",
      "newCircuit": "+ Nuovo circuito",
      "groupCta": "+ Superset"
    },
    "webview": {
      "close": "Chiudi",
      "openExternal": "Apri nel browser",
      "errorTitle": "La pagina non si è caricata",
      "errorBody": "Tocca qui sotto per provare nel browser di sistema.",
      "fallbackErrorTitle": "Impossibile aprire il browser",
      "fallbackErrorBody": "Riprova da un'altra connessione."
    },
    "plates": {
      "title": "Calcolatore dischi",
      "close": "Chiudi",
      "apply": "Applica",
      "targetLabel": "Obiettivo",
      "barLabel": "Bilanciere",
      "perSide": "Per lato: {{kg}} kg",
      "barOnly": "Solo bilanciere — nessun disco.",
      "pairs_one": "{{count}} coppia",
      "pairs_other": "{{count}} coppie",
      "plates_one": "{{count}} disco",
      "plates_other": "{{count}} dischi",
      "loadedEnd": "Estremità caricata: {{kg}} kg",
      "landmineHint": "Landmine: solo l'estremità libera viene caricata. L'altra è ancorata al perno a terra.",
      "remainder": "Mancano {{kg}} kg — l'inventario non corrisponde esattamente.",
      "belowBar": "Obiettivo inferiore al bilanciere.",
      "invalid": "Inserisci un peso valido.",
      "inventoryShow": "Modifica i dischi disponibili",
      "inventoryHide": "Nascondi i dischi disponibili",
      "inventoryTitle": "Coppie disponibili",
      "pairsIncrement": "Aggiungi una coppia",
      "pairsDecrement": "Rimuovi una coppia",
      "signLabel": "SEGNO EXTRA",
      "signAdd": "+ Peso aggiunto",
      "signAssist": "− Assistito"
    },
    "restTimerScreen": {
      "title": "Timer",
      "back": "Indietro"
    },
    "licenses": {
      "title": "Licenze open source",
      "back": "Indietro",
      "headlineIntro": "JackedLogs si appoggia a un piccolo gruppo di librerie che danno forma all'app. Tocca una riga per aprire il progetto — e considera di sostenere quelle che usi di più.",
      "coreSection": "Librerie principali ({{count}})",
      "viewAllTitle": "Mostra tutti i pacchetti",
      "viewAllSub": "Attribuzione completa per i {{count}} pacchetti inclusi nell'APK, raggruppati per progetto.",
      "allTitle": "Tutti i pacchetti ({{count}})",
      "searchAll": "Cerca nome, gruppo, licenza o autore",
      "groupOther": "Altri pacchetti",
      "empty": "Nessun pacchetto corrisponde alla ricerca.",
      "footer": "Generato il {{date}}",
      "openErrorTitle": "Impossibile aprire il link"
    },
    "share": {
      "newPR": "NUOVO PR",
      "topLifts": "TOP ESERCIZI",
      "durationMinute": "min",
      "durationHour": "h",
      "durationMinuteShort": "m",
      "footerSets": "serie",
      "footerDensitySuffix": "/min",
      "fallbackLabel": "Volume Totale",
      "timeLabel": "Tempo Totale",
      "tutLabel": "TUT",
      "impulseUnit": "kg·s",
      "impulseLabel": "Impulso",
      "e1rmSuffix": "E1RM"
    },
    "postSession": {
      "blockCalories": "Calorie",
      "blockEffort": "Sforzo",
      "effortHr": "{{avg}} media · {{peak}} picco bpm",
      "effortHrMax": "{{pct}}% FCmax",
      "shareTitle": "Sessione JackedLogs",
      "shareErrorTitle": "Condivisione fallita",
      "headlineLabelPR": "NUOVO E1RM",
      "headlineLabelDelta": "GRANDE BALZO +{{delta}}",
      "headlineLabelSolid": "SESSIONE SOLIDA",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} serie",
      "blockTopLifts": "Top esercizi",
      "fromSet": "da {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durata",
      "blockDensity": "Densità",
      "barsTitle": "Lavoro per muscolo",
      "bodyTitle": "Muscoli allenati",
      "sharing": "Preparazione…",
      "shareCta": "Condividi scheda sessione",
      "done": "Fatto",
      "summaryTitle": "Allenamento salvato"
    },
    "common": {
      "back": "Indietro",
      "save": "Salva",
      "cancel": "Annulla",
      "close": "Chiudi"
    },
    "account": {
      "title": "Account",
      "navSub": "Nome, password, esporta, elimina, esci",
      "nameLabel": "NOME",
      "namePlaceholder": "Il tuo nome",
      "saved": "Salvato",
      "passwordLabel": "CAMBIA PASSWORD",
      "currentPassword": "Password attuale",
      "newPassword": "Nuova password",
      "confirmPassword": "Conferma nuova password",
      "passwordChanged": "Password cambiata.",
      "passwordSubmit": "Aggiorna password",
      "deleteNeedsConnection": "Per cancellare l'account serve una connessione. Riconnettiti e riprova: questa richiesta non viene mai messa in coda."
    },
    "prefs": {
      "title": "Unità e visualizzazione",
      "navSub": "Unità, lingua, suggerimenti",
      "unitsLabel": "Unità",
      "unitsHelp": "Unità di peso predefinita per le nuove serie. Puoi comunque cambiarla per riga nel logger.",
      "weekStartLabel": "La settimana inizia il",
      "weekStartHelp": "Il giorno in cui riparte la tua settimana di allenamento. Gli obiettivi settimanali per muscolo contano da qui.",
      "unitsKg": "Chilogrammi (kg)",
      "unitsLb": "Libbre (lb)",
      "glucoseUnitsLabel": "Unità glicemia",
      "glucoseUnitsHelp": "Come viene mostrata e inserita la glicemia. Salvata allo stesso modo.",
      "glucoseMmol": "mmol/L",
      "glucoseMgdl": "mg/dL",
      "themePaletteLabel": "Palette del tema",
      "themePaletteHelp": "Scegli la palette di colori usata in tutta l'app.",
      "themeModeLabel": "Aspetto",
      "themeModeHelp": "Segui l'impostazione di sistema, oppure forza chiaro o scuro.",
      "themeMode": {
        "system": "Sistema",
        "light": "Chiaro",
        "dark": "Scuro"
      }
    },
    "timeline": {
      "setNumber": "Serie {{n}}",
      "fail": "Fallita",
      "failTip": "Fallita registra la serie come tentata ma non completata. Conta comunque come eseguita (parte il timer di recupero), mostra ✕ nella timeline ed è esclusa dall'e1RM.",
      "failTipA11y": "Cosa significa Fallita?",
      "e1rmValue": "e1RM {{value}}",
      "e1rmPctOfBest": "{{pct}}% del best",
      "e1rmNewBest": "record",
      "e1rmLegend": "e1RM",
      "setVolume": "Σ {{value}} {{unit}}",
      "myorepTag": "Myo-rep",
      "dropsetTag": "Drop",
      "myorepA11y": "Serie myo-rep",
      "dropsetA11y": "Serie dropset",
      "setVolumeA11y": "Volume del set {{value}} {{unit}}",
      "setSummaryBothSidesA11y": "{{reps}} ripetizioni a {{weight}} {{unit}} per lato, contati entrambi i lati",
      "e1rmLegendA11y": "Cos'è l'e1RM?",
      "e1rmTip": "L'e1RM è il tuo massimale stimato su 1 ripetizione per la serie (Epley, rip ≤ 12). «% del best» lo confronta col tuo miglior e1RM nello storico recente — più basso = margine per spingere; ↑ record = nuovo massimale stimato.",
      "durationLabel": "Durata",
      "hourShort": "h",
      "minShort": "min",
      "secShort": "sec",
      "started": "Allenamento avviato",
      "addSet": "Aggiungi serie",
      "removeSet": "Rimuovi serie",
      "prevSet": "Serie precedente",
      "nextSet": "Serie successiva",
      "allLogged": "Tutte le serie registrate — tocca + per aggiungerne.",
      "rosterLabel": "Esercizi",
      "rosterHint": "tocca per cambiare",
      "focusEmptyHasRoster": "Seleziona un esercizio qui sopra per iniziare, oppure aggiungine uno nuovo.",
      "focusAllLogged": "Tutte le serie registrate. Aggiungi un esercizio qui sopra, o salva qui sotto.",
      "cueNextSet": "→ Serie {{n}}/{{total}}",
      "cueNextExercise": "→ {{name}}",
      "rosterExpandA11y": "Espandi la lista degli esercizi",
      "rosterCollapseA11y": "Comprimi la lista degli esercizi",
      "rosterState": {
        "done": "completato",
        "inProgress": "in corso",
        "notDone": "da iniziare"
      },
      "rosterOccurrenceA11y": "{{label}} ({{index}} di {{count}})",
      "exerciseNote": "Nota esercizio",
      "notePlaceholder": "Aggiungi una nota alla timeline…",
      "noteSend": "Invia nota",
      "noteExpandA11y": "Nota — tocca per leggerla tutta",
      "noteDeleteA11y": "Elimina nota",
      "dropsetActive": "Dropset — modifica i round qui sotto.",
      "editingLogged": "Modifica della serie {{n}} registrata — le modifiche si salvano col workout.",
      "addSetLocked": "Stai modificando una sessione passata: non puoi aggiungere serie. Correggi i valori o rimuovi una serie.",
      "createGroupLocked": "Stai modificando una sessione passata: non puoi creare un superset.",
      "splitGroupLocked": "Stai modificando una sessione passata: non puoi sciogliere un superset.",
      "setTypeLocked": "Stai modificando una sessione passata: non puoi cambiare il tipo di serie (dropset/myorep).",
      "addStepLocked": "Stai modificando una sessione passata: non puoi aggiungere uno step al dropset.",
      "setState": {
        "pending": "Serie {{n}} di {{total}}, da fare",
        "done": "Serie {{n}} di {{total}}, completata",
        "pr": "Serie {{n}} di {{total}}, record personale",
        "failed": "Serie {{n}} di {{total}}, fallita"
      },
      "holdLabel": "Tenuta"
    },
    "home": {
      "targetsTopPatterns": "Pattern principali",
      "targetsSummary": "{{on}} di {{total}} a target",
      "targetsHint": "Fissa un programma con target settimanali per valutarli rispetto a un obiettivo.",
      "targetsZoneOnTarget": "a target",
      "targetsZoneOver": "oltre",
      "targetsZoneUnder": "in crescita",
      "targetsNoCoverage": "non previsto",
      "targetsPrescribed": "piano {{n}}",
      "targetsEmptyTitle": "Nessun obiettivo ancora",
      "targetsEmptySub": "Imposta quanto vuoi allenare ogni muscolo a settimana. Il tuo piano ci lavora sopra; il meter Home ti dice a che punto sei.",
      "targetsEmptyCta": "Imposta i tuoi obiettivi",
      "weekEyebrow": "Questa settimana",
      "weeklyTitle": "Ultimi 7 giorni",
      "weeklySessions": "Allenamenti",
      "weeklyVolume": "Volume",
      "weeklyA11y": "{{sessions}} allenamenti, {{volume}} di volume",
      "viewProgress": "Vedi progressi",
      "badgesTitle": "Badge",
      "newsTitle": "Novità",
      "newsEmpty": "Le novità dell'app compariranno qui.",
      "prPrev": "Record precedente",
      "prNext": "Record successivo",
      "prPosition": "Record {{n}} di {{total}}",
      "eyebrow": "OGGI",
      "blankTitle": "Pronto ad allenarti?",
      "blankLoading": "Caricamento del piano…",
      "blankBody": "Nessun programma attivo al momento. Avvia un allenamento vuoto, o usa ＋ per pianificarne uno.",
      "newWorkout": "Nuovo allenamento",
      "programMeta": "{{program}} · Settimana {{week}}",
      "morePreview": " +altri {{count}}",
      "startToday": "▶ Avvia sessione",
      "blankInstead": "Avvia invece un allenamento vuoto",
      "recentPrValue": "{{weight}} × {{reps}}",
      "recentPrValueBodyweight": "{{reps}} reps PC",
      "prToday": "Oggi",
      "prDaysAgo": "{{n}} g fa",
      "weightTitle": "Peso corporeo",
      "weightSaved": "Salvato ✓",
      "weightCurrent": "Ultimo: {{value}} {{unit}}",
      "weightNone": "Registra il peso per seguire l'andamento.",
      "weightSave": "Salva",
      "repeatWorkout": "Ripeti un allenamento",
      "form": {
        "title": "Prontezza",
        "ready": "Pronto",
        "caution": "Attenzione",
        "rest": "Riposo",
        "reasonNoData": "Registra una sessione per iniziare a monitorare la prontezza.",
        "reasonWellRecovered": "Ben riposato dall'ultima sessione — puoi spingere.",
        "reasonBalanced": "Il tuo carico di allenamento sembra equilibrato.",
        "reasonFreshStart": "Stai riprendendo — vai con calma e costruisci una base.",
        "reasonShortRest": "Sessioni ravvicinate — tieni d'occhio il recupero.",
        "reasonHighFrequency": "Settimana ad alto volume — valuta un giorno più leggero.",
        "reasonLoadSpike": "Il carico è salito molto rispetto alla media recente.",
        "reasonLongGap": "È passato un po' — riparti leggero per risalire."
      },
      "glucoseSave": "Salva",
      "weightSaveA11y": "Salva il peso corporeo",
      "glucoseSaveA11y": "Salva la glicemia"
    },
    "superset": {
      "startingWith": "Inizia il superset con",
      "joinExisting": "Unisci a esistente",
      "pairInWorkout": "Abbina (in questo allenamento)",
      "templates": "Superset salvati",
      "templateInsertHint": "Inserisci questo superset; tieni premuto per eliminare",
      "templateDeleteBody": "Rimuovere questo superset salvato?",
      "createCta": "Crea superset ({{n}})",
      "cueCycle": "{{group}}, esercizio {{pos}} di {{total}}. Tocca per andare a {{next}}.",
      "cueStatic": "{{group}}, esercizio {{pos}} di {{total}}",
      "menuOpen": "Opzioni superset",
      "menuSaveTemplate": "Salva come template",
      "menuAddExercise": "Aggiungi esercizio",
      "menuMoveUp": "Sposta su",
      "menuMoveDown": "Sposta giù",
      "menuRemoveMember": "Rimuovi questo esercizio",
      "menuSplit": "Sciogli superset",
      "namePlaceholder": "Nome del superset (facoltativo)"
    }
  },
  "tabs": {
    "workout": "Allenamento",
    "plan": "Pianifica",
    "progress": "Progressi",
    "profile": "Profilo",
    "catalog": "Catalogo",
    "admin": "Admin",
    "workoutEyebrow": "Sessione di oggi",
    "planEyebrow": "Programmazione",
    "progressEyebrow": "Grafici e report",
    "profileEyebrow": "Account e massimali",
    "catalogEyebrow": "Catalogo esercizi",
    "adminEyebrow": "Console admin",
    "progressEmpty": "Registra prima una sessione — i grafici compaiono quando ci sono dati."
  },
  "shell": {
    "navAria": "Navigazione principale"
  },
  "theme": {
    "aria": "Tema",
    "light": "Chiaro",
    "dark": "Scuro",
    "auto": "Auto"
  },
  "import": {
    "title": "Importa allenamenti da CSV",
    "help": "Carica un export da un altro tracker. Confermi di essere il proprietario dei dati e di assumerti la responsabilità di ciò che viene importato in JackedLogs. Gli allenamenti già importati vengono rilevati per id e saltati.",
    "sourceLabel": "Piattaforma sorgente",
    "source": {
      "strengthlog": "StrengthLog"
    },
    "sourceHint": {
      "strengthlog": "Da StrengthLog: apri Impostazioni, poi Export, scegli Logs full export. Salva il CSV dove vuoi e selezionalo qui sotto. Il nome del file originale non importa."
    },
    "languageDisclaimer": "I nomi degli esercizi vengono confrontati in inglese. Nomi in altre lingue verranno creati come esercizi draft, da rinominare a mano nel catalogo.",
    "consent": "Ho esportato io stesso questo file dal mio account e sono il proprietario dei dati.",
    "fileLabel": "File CSV",
    "parsing": "Lettura del file in corso…",
    "cancel": "Annulla",
    "confirm": "Avvia importazione",
    "again": "Importa un altro file",
    "done": "Importazione conclusa",
    "seedMaxesPrompt": "Vuoi seedare i MAX dagli allenamenti importati? La tab Profilo ha un suggerimento one-click basato su ogni set che hai appena importato.",
    "seedMaxesGo": "Seed MAX dalla history",
    "summary": {
      "rows": "{{count}} righe",
      "sessions": "{{count}} sessioni",
      "exercises": "{{count}} esercizi",
      "dateRange": "dal {{from}} al {{to}}",
      "autoMatched": "{{count}} corrispondono al catalogo",
      "draftsToCreate": "{{count}} esercizi verranno creati come draft",
      "unparseable": "{{count}} nomi non producono uno slug e verranno saltati",
      "unparseableShow": "Mostra i nomi"
    },
    "draftsCallout": "I draft hanno il flag auto_imported. Sono usabili da subito per loggare. Un atleta o un coach potrà rivederli e promuoverli in seguito, aggiungere muscoli ed equipaggiamento, o fonderli con duplicati.",
    "draftsProgress": "Creazione draft: {{done}} / {{total}}",
    "mappingsTitle": "Associazione esercizi",
    "mappingsStats": "{{matched}} associati automaticamente · {{pending}} da risolvere · {{resolved}} risolti · {{skipped}} saltati",
    "allResolved": "Tutti gli esercizi sono risolti. Puoi avviare l'import.",
    "confidenceHint": "Più simile: {{top}} ({{pct}}%)",
    "toggle": {
      "showResolved": "Mostra i risolti ({{count}})",
      "hideResolved": "Nascondi i risolti",
      "showMatched": "Mostra gli associati automaticamente ({{count}})",
      "hideMatched": "Nascondi gli associati automaticamente"
    },
    "action": {
      "create": "Crea come nuovo esercizio",
      "pickExisting": "Usa uno già esistente",
      "skip": "Salta"
    },
    "create": {
      "name": "Nome esercizio",
      "bodyweight": "Esercizio a corpo libero (senza carico esterno)",
      "submit": "Crea",
      "submitting": "Creazione…"
    },
    "pick": {
      "label": "Esercizio dal catalogo",
      "placeholder": "Scegline uno…",
      "rememberAlias": "Ricorda \"{{csvName}}\" come alias per le importazioni future",
      "submit": "Conferma",
      "submitting": "Salvataggio…"
    },
    "skip": {
      "help": "Le serie su questo esercizio non verranno importate. Puoi cambiare idea sotto.",
      "submit": "Conferma salto"
    },
    "resolved": {
      "auto": "→ {{name}} (auto)",
      "linked": "→ {{name}} (associato)",
      "linkedAlias": "→ {{name}} (associato, alias salvato)",
      "created": "→ {{name}} (creato)",
      "skipped": "saltato",
      "undo": "Annulla"
    },
    "mapping": {
      "suggestions": "Suggerimenti",
      "allCatalog": "Tutto il catalogo"
    },
    "progress": {
      "label": "{{done}} / {{total}} ({{pct}}%)",
      "tally": "Creati {{created}} · Già presenti {{duplicates}} · Falliti {{failed}}"
    },
    "report": {
      "created": "Allenamenti creati: {{count}}",
      "duplicates": "Già presenti: {{count}}",
      "draftsCreated": "Draft esercizi creati: {{count}}",
      "invalid": "Payload non valido: {{count}}",
      "unknownExercise": "Esercizio sconosciuto: {{count}}",
      "failed": "Falliti: {{count}}",
      "detailsToggle": "Mostra i fallimenti",
      "moreFailures": "e altri {{more}}"
    },
    "errors": {
      "catalogNotReady": "Il catalogo esercizi è ancora in caricamento. Aspetta un momento e riseleziona il file.",
      "emptyFile": "Nessuna riga trovata nel file.",
      "missingColumns": "Colonne richieste mancanti: {{columns}}.",
      "parseFailed": "Impossibile leggere il file.",
      "nothingToImport": "Niente da importare dopo la creazione dei draft. Controlla il file.",
      "draftsFailed": "Impossibile creare i draft: {{message}}"
    }
  },
  "settings": {
    "restDefaults": {
      "title": "Default rest timer",
      "globalLabel": "Default globale",
      "globalUnset": "Non impostato — uso {{n}}s",
      "customLabel": "Esercizi con default personalizzato",
      "customEmpty": "Nessun override per esercizio. Apri il banner di rest nel Logger e tocca ⚙ per impostarne uno.",
      "customRemoveA11y": "Rimuovi rest personalizzato per {{name}}",
      "clearGlobal": "Reset"
    },
    "hints": {
      "title": "Suggerimenti",
      "label": "Mostra i suggerimenti",
      "help": "Tocca l'intestazione di una colonna per sapere cosa significa. Disattiva per nascondere i suggerimenti."
    },
    "effortNudge": {
      "label": "Promemoria sforzo",
      "help": "Un impulso raro e discreto sulla barra dello sforzo quando un set aspetta di essere loggato."
    },
    "inWorkoutMeter": {
      "label": "Meter target in allenamento",
      "help": "Una striscia in cima alla card dell'esercizio con il target settimanale dei muscoli che stai allenando."
    },
    "audio": {
      "title": "Audio",
      "soundLabel": "Suono timer",
      "soundHelp": "Suona quando il timer di riposo termina.",
      "vibrationLabel": "Vibrazione",
      "vibrationHelp": "Vibra quando il timer di riposo termina.",
      "previewButton": "Ascolta",
      "pickerTitle": "Scegli un suono",
      "pickerCancel": "Annulla",
      "category": {
        "serious": "Standard",
        "fun": "Buffi"
      },
      "soundOptions": {
        "none": "Nessuno",
        "chime_crisp": "Campanella",
        "ding_dong": "Din-don",
        "meditation_bell": "Campana tibetana",
        "tada_fanfare": "Ta-da",
        "cartoon_boing": "Boing",
        "ah_yeah": "Yeah!"
      }
    },
    "timerDefaults": {
      "range": "Inserisci {{min}}–{{max}}s",
      "globalTitle": "Default globali",
      "restGlobal": "Timer di recupero",
      "holdGlobal": "Timer di tenuta",
      "customLabel": "Override per esercizio",
      "customEmpty": "Nessun override per esercizio. Tocca + Aggiungi.",
      "unset": "Non impostato — {{n}}s",
      "add": "+ Aggiungi",
      "editRestA11y": "Modifica recupero per {{name}}",
      "editHoldA11y": "Modifica tenuta per {{name}}",
      "editA11y": "Modifica i timer di {{name}}",
      "isDefault": "default",
      "equalsDefaultHint": "Un valore lasciato uguale al default globale non viene salvato come override.",
      "remove": "Rimuovi"
    },
    "backend": {
      "section": "Backend",
      "title": "Backend",
      "navSub": "Scegli dove scrive questa app",
      "pickLabel": "Scrivi i miei dati su",
      "pickHelp": "Solo build dev. Ogni backend tiene le sue sessioni, le sue code e la sua bozza di allenamento: cambiare non tocca l’altro.",
      "stageProduction": "PRODUZIONE",
      "stageLab": "LABORATORIO",
      "liveLabel": "STAI SCRIVENDO SU",
      "liveChecking": "Controllo…",
      "liveUnknown": "Sconosciuto — il backend non ha risposto",
      "liveNotProduction": "Qui non c’è il tuo allenamento vero.",
      "confirmTitle": "Cambiare backend?",
      "confirmBody": "L’app si ricarica su {{stage}}. Lì potresti dover entrare di nuovo, e le liste in cache vengono buttate.",
      "confirmCta": "Cambia",
      "blockedByQueue": "Non cambiato: alcune scritture non sono ancora partite. Torna online e lascia svuotare le code."
    },
    "animations": {
      "cellularLabel": "Scarica le animazioni anche senza Wi-Fi",
      "cellularHelp": "Spento di default. Le animazioni ci sono comunque: questo permette solo all'app di portarsele avanti su rete mobile, fra i 20 e i 30 MB per un programma."
    }
  },
  "web": {
    "preauth": {
      "tagline": "Allenamento della forza che si costruisce sul tuo sforzo, su come stai adesso e sull'attrezzatura che hai davvero.",
      "status": "In sviluppo. Registrazione chiusa.",
      "contactLabel": "Accesso o informazioni"
    },
    "crash": {
      "body": "L'app ha incontrato un errore imprevisto. I tuoi dati salvati sono al sicuro — ricarica per continuare.",
      "reload": "Ricarica"
    },
    "postSession": {
      "headlineLabelPR": "NUOVO E1RM",
      "headlineLabelDelta": "GRANDE BALZO +{{delta}}",
      "headlineLabelSolid": "SESSIONE SOLIDA",
      "headlineSolidValue": "{{volume}} in {{duration}}",
      "headlineFallback": "{{label}} — {{sets}} serie",
      "blockE1rm": "E1RM",
      "fromSet": "da {{weight}} × {{reps}}",
      "blockVolume": "Volume",
      "blockDuration": "Durata",
      "blockDensity": "Densità",
      "barsTitle": "Lavoro per muscolo",
      "bodyTitle": "Muscoli allenati",
      "sharing": "Preparazione…",
      "shareCta": "Condividi scheda sessione"
    }
  },
  "muscle": {
    "quadriceps": "Quadricipiti",
    "hamstrings": "Ischiocrurali",
    "glutes": "Glutei",
    "adductors": "Adduttori",
    "abductors": "Abduttori",
    "calves": "Polpacci",
    "core": "Core",
    "obliques": "Obliqui",
    "erectors": "Lombari",
    "pectoralis": "Petto",
    "anterior-delts": "Deltoidi anteriori",
    "lateral-delts": "Deltoidi laterali",
    "triceps": "Tricipiti",
    "lats": "Dorsali",
    "rhomboids": "Romboidi",
    "rear-delts": "Deltoidi posteriori",
    "traps": "Trapezi",
    "biceps": "Bicipiti",
    "forearms": "Avambracci"
  },
  "experience": {
    "menuLabel": "Profilo attivo",
    "athlete": "Atleta",
    "coach": "Coach",
    "admin": "Admin"
  },
  "composer": {
    "targetAxisExercise": "Esercizio",
    "targetKeyExercise": "Esercizio",
    "targetRefAvg": "~{{n}}/sett media",
    "targetRefLast": "ultima sett {{n}}",
    "targetRefNone": "Nessun dato nelle ultime 4 settimane",
    "targetRefProgram": "il programma prescrive ~{{n}}/sett",
    "targetUseAvg": "Usa la media",
    "targetUseProgram": "Usa valore programma",
    "projectionTitle": "Come cadono i target",
    "projectionWeek": "Settimana {{n}}",
    "projectionContext": "Set / carico che il programma prescrive nella settimana {{n}}.",
    "projectionTarget": "Target",
    "projectionWeekTotal": "Sett.",
    "projectionRamp": "Ciclo",
    "projectionWeekShort": "S{{n}}",
    "projectionEmpty": "Non previsto",
    "targetsTitle": "Target settimanali",
    "targetsEmptyTitle": "Nessun target settimanale",
    "targetsEmptySub": "Aggiungine uno per attivare il meter di livello.",
    "targetAdd": "Aggiungi target",
    "targetRemove": "Rimuovi target {{name}}",
    "targetCollapse": "Chiudi",
    "targetAxis": "Asse",
    "targetAxisMuscle": "Muscolo",
    "targetMetric": "Metrica",
    "targetMetricHardSets": "Hard set",
    "targetMetricTonnage": "Tonnellaggio",
    "targetMetricReps": "Reps",
    "prescriptionEyebrow": "Prescrizione",
    "prescriptionSub": "Ciò che questo blocco prescrive ogni settimana, confrontato con i tuoi obiettivi.",
    "targetKeyMuscle": "Muscolo",
    "targetValue": "Obiettivo settimanale",
    "targetUnitHardSets": "hard set",
    "targetUnitTonnage": "kg",
    "targetUnitReps": "reps",
    "targetBand": "±{{pct}}%",
    "targetNotScored": "non ancora nel meter",
    "targetNotScoredNote": "Questo tipo di target non è ancora nel level meter.",
    "targetBandLabel": "Tolleranza",
    "targetBandAsym": "−{{lo}}% / +{{hi}}%",
    "targetBandBelow": "Percentuale sotto l'obiettivo",
    "targetBandAbove": "Percentuale sopra l'obiettivo",
    "targetBandRange": "Sotto 0–99%, sopra 0% o più.",
    "compose": "Componi",
    "preview": "Anteprima",
    "addExercises": "Aggiungi esercizi",
    "editingBlockDay": "Stai modificando D{{d}} — Aggiorna agisce su questo giorno (seleziona altri giorni per applicarlo anche lì)",
    "editingRampDay": "Ramp settimanale su D{{d}} — Aggiorna agisce sulle settimane selezionate, solo questo giorno",
    "segments": "Segmenti",
    "rampSwitchHint": "Aggiorna o Annulla prima di cambiare segmento",
    "setupHint": "Imposta la forma iniziale — potrai aggiungere o togliere giorni e cambiare le settimane dopo, nell'editor.",
    "repsHint": "Reps «5+» = AMRAP: minimo 5, poi quante ne riesci.",
    "repsHintA11y": "Come si scrivono le ripetizioni",
    "addingWeek": "Nuova settimana W{{n}} — Aggiorna la aggiunge a questo esercizio",
    "cloneWeek": "Clona settimana…",
    "cloneWeekFrom": "Da",
    "cloneWeekApply": "Clona",
    "cloneWeekConflict": "{{name}} ha già contenuto in W{{week}} (D{{day}})",
    "cloneWeekEmpty": "Niente da clonare — scegli una settimana sorgente piena e almeno una destinazione",
    "cloneDayEmpty": "Niente da clonare in questo giorno",
    "editingWeekDay": "Stai modificando solo W{{n}} su D{{d}} — Aggiorna la stacca dal segmento",
    "perWeek": "Per settimana",
    "dupExercise": "{{name}} è già presente in D{{day}} nelle settimane selezionate",
    "cloneDay": "Clona D{{n}} su…",
    "cloneDayTarget": "Su",
    "days": "Giorni",
    "weeks": "Settimane",
    "setNote": "Nota del set",
    "removeExercise": "Rimuovi esercizio",
    "replaceExercise": "Sostituisci esercizio",
    "clone": "Clona",
    "remove": "Rimuovi",
    "removeConfirm": "Confermi? ({{n}} celle)",
    "verbatim": "Slot avanzato (multi-variante) — conservato tale e quale, non modificabile qui",
    "metaWeeks": "{{n}} settimane",
    "metaDays": "{{n}} giorni di allenamento",
    "gridToggle": "Griglia intensità",
    "addDay": "Aggiungi giorno",
    "removeDay": "Rimuovi giorno D{{n}}",
    "removeDayConfirm": "Conferma — rimuovi giorno D{{n}}?",
    "dayEmpty": "Nessun esercizio in questo giorno. Aggiungine uno per costruirlo.",
    "prescribeDayEmpty": "Nessun esercizio in questo giorno.",
    "prescribeFocusEmpty": "Tocca un esercizio qui sopra per prescriverne le serie.",
    "prescribeViewMatrix": "Matrice",
    "prescribeViewEditor": "Editor",
    "prescribeViewGroup": "Cambia vista",
    "checkEmptyCell": "W{{w}}·D{{d}} non ha esercizi",
    "checkPctNoMax": "{{name}} usa %MAX senza un MAX salvato",
    "exerciseNote": "Nota per l'esercizio",
    "exerciseNotePlaceholder": "Nota per questo esercizio (visibile durante il log)",
    "panelHint": "Tocca un esercizio per modificare, clonare o rimuovere",
    "warnLine_one": "{{count}} avviso",
    "warnLine_other": "{{count}} avvisi",
    "adjacencyWarnLine_one": "{{count}} avviso di recupero muscolare",
    "adjacencyWarnLine_other": "{{count}} avvisi di recupero muscolare",
    "adjacencyWarnItem": "{{muscle}} allenato in giorni adiacenti ({{count}}×)",
    "publishChecklist": "Avvisi aperti (puoi pubblicare comunque)",
    "publishClean": "Nessun avviso aperto.",
    "weekShort": "Settimana",
    "placed": "attivo",
    "notPlaced": "spento",
    "placementHint": "Tieni premuta una cella per metterlo o toglierlo lì.",
    "addWeek": "Aggiungi settimana",
    "removeWeek": "Rimuovi settimana",
    "removeWeekConfirm": "Conferma — togli questa settimana e i suoi set",
    "coverageTitle": "Copertura — set duri/settimana",
    "coverageHint": "Media sull'intero ciclo. Uno zero si vede qui prima di allenarlo."
  },
  "gym": {
    "setPlace": "Dove?",
    "whichPlace": "Dove ti alleni?",
    "newPlace": "Aggiungi posto",
    "fallback": "Predefinito",
    "chipA11y": "Luogo di allenamento",
    "footnote": "Ordina cosa vedi per primo. Non arriva mai a un coach.",
    "namePlaceTitle": "Dai un nome a questo posto",
    "namePlaceHint": "Nome del posto",
    "namePlaceSave": "Usa questo posto",
    "pinPlace": "Imposta {{place}} come luogo predefinito",
    "unpinPlace": "Togli {{place}} come luogo predefinito",
    "pinHint": "Ricorda questo come il luogo dove ti alleni di solito.",
    "unpinHint": "Dimentica il tuo luogo predefinito.",
    "pinErrorTitle": "Non salvato",
    "pinErrorBody": "Il tuo luogo predefinito non è cambiato."
  }
}
